import Vue from 'vue';
import Router from 'vue-router';

//重写路由，避免出现这种错误：Navigating to current location ("/manage/user") is not allowed
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);


export default new Router({
  // mode: 'history',
  //hashbang: false, history: true,
  routes: [
    //设置路由
    {
      path: '',
      redirect: '/Login'
    },


    /*
     ******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************
     ******** 管理端 ******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************
     */
    {
      path: '/Login',
      name: 'Admin_Login',
      component: () =>
        import('../views/Login.vue'),
      meta: {
        title: "登录 - " + webTitleName() + " - " + schoolName()
      }
    },
    {
      path: '/Registration',
      name: 'Admin_Registration',
      component: () =>
        import('../views/Registration.vue'),
      meta: {
        title: "新生报名 - " + webTitleName() + " - " + schoolName()
      }
    },
    {
          path: '/Prompt',
          name: 'Student_Prompt',
          component: () =>
            import('../views/Prompt.vue'),
          meta: {
            title: webTitleName() + " - " + schoolName()
          },
      },
      {
            path: '/results',
            name: 'Student_results',
            component: () =>
              import('../views/results.vue'),
            meta: {
              title: webTitleName() + " - " + schoolName()
            },
        },
    {
      path: '/Admin/Default',
      name: 'Admin_Default',
      component: () =>
        import('../views/Admin/Default.vue'),
      meta: {
        title: webTitleName() + " - " + schoolName()
      },
      redirect: '/Admin/Home/Default', // 默认起始页
      children: [
        //**********> Home <*************** 首页
        {
          path: '/Admin/Home/Index',
          name: 'Admin_Home_Index',
          component: () =>
            import('../views/Admin/Home/Index.vue'),
          meta: {
            title: webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Home/Home',
          name: 'Admin_Home_Home',
          component: () =>
            import('../views/Admin/Home/Home.vue'),
          meta: {
            title: webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Home/Default',
          name: 'Admin_Home_Default',
          component: () =>
            import('../views/Admin/Home/Default.vue'),
          meta: {
            title: webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          学生缴费管理
        *******************************************************************************************/
        {
          path: '/Admin/Payment/ListOfFees/Index',
          name: 'Admin_Payment_ListOfFees_Index',
          component: () =>
            import('../views/Admin/Payment/ListOfFees/Index.vue'),
          meta: {
            title: "缴费管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Payment/ListOfFees/List',
          name: 'Admin_Payment_ListOfFees_List',
          component: () =>
            import('../views/Admin/Payment/ListOfFees/List.vue'),
          meta: {
            title: "学生缴费信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Payment/ListOfFees/Details/:Id',
          name: 'Admin_Payment_ListOfFees_Details',
          component: () =>
            import('../views/Admin/Payment/ListOfFees/Details.vue'),
          meta: {
            title: "缴费管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Payment/PayFees/Index',
          name: 'Admin_Payment_PayFees_Index',
          component: () =>
            import('../views/Admin/Payment/PayFees/Index.vue'),
          meta: {
            title: "缴费管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Payment/PayFees/Details/:Id',
          name: 'Admin_Payment_PayFees_Details',
          component: () =>
            import('../views/Admin/Payment/PayFees/Details.vue'),
          meta: {
            title: "缴费管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Payment/Refund/Index',
          name: 'Admin_Payment_Refund_Index',
          component: () =>
            import('../views/Admin/Payment/Refund/Index.vue'),
          meta: {
            title: "缴费管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Payment/Refund/Details/:Id',
          name: 'Admin_Payment_Refund_Details',
          component: () =>
            import('../views/Admin/Payment/Refund/Details.vue'),
          meta: {
            title: "缴费管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          在线考试成绩
        *******************************************************************************************/
        {
          path: '/Admin/Score/Exam',
          name: 'Admin_Score_Exam',
          component: () =>
            import('../views/Admin/Score/Exam.vue'),
          meta: {
            title: "在线考试成绩 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          微信群发
        *******************************************************************************************/
        {
          path: '/Admin/Wechat/Index',
          name: 'Admin_Wechat_Index',
          component: () =>
            import('../views/Admin/Wechat/Index.vue'),
          meta: {
            title: "微信群发 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Wechat/Create',
          name: 'Admin_Wechat_Create',
          component: () =>
            import('../views/Admin/Wechat/Update.vue'),
          meta: {
            title: "微信群发 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Wechat/Edit/:Id',
          name: 'Admin_Wechat_Edit',
          component: () =>
            import('../views/Admin/Wechat/Update.vue'),
          meta: {
            title: "微信群发 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Wechat/Details/:Id',
          name: 'Admin_Wechat_Details',
          component: () =>
            import('../views/Admin/Wechat/Details.vue'),
          meta: {
            title: "微信群发 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          放假管理
        *******************************************************************************************/
        {
          path: '/Admin/HolidaySettings/Index',
          name: 'Admin_HolidaySettings_Index',
          component: () =>
            import('../views/Admin/HolidaySettings/Index.vue'),
          meta: {
            title: "放假管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          各类统计
        *******************************************************************************************/
        {
          path: '/Admin/Statistics/Index',
          name: 'Admin_Statistics_Index',
          component: () =>
            import('../views/Admin/Statistics/Index.vue'),
          meta: {
            title: "各类统计 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Statistics/Major',
          name: 'Admin_Statistics_Major',
          component: () =>
            import('../views/Admin/Statistics/Major.vue'),
          meta: {
            title: "各类统计 - " + webTitleName() + " - " + schoolName()
          },
        },
        {// 缴费统计
          path: '/Admin/Statistics/Financefile',
          name: 'Admin_Statistics_Financefile',
          component: () =>
            import('../views/Admin/Statistics/Financefile.vue'),
          meta: {
            title: "各类统计 - " + webTitleName() + " - " + schoolName()
          },
        },
        

        /******************************************************************************************
          工作台
        *******************************************************************************************/
        {
          path: '/Admin/Workbench/Affairs',
          name: 'Admin_Workbench_Affairs',
          component: () =>
            import('../views/Admin/Workbench/Affairs.vue'),
          meta: {
            title: "工作台 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Workbench/Personnel',
          name: 'Admin_Workbench_Personnel',
          component: () =>
            import('../views/Admin/Workbench/Personnel.vue'),
          meta: {
            title: "工作台 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Workbench/Student',
          name: 'Admin_Workbench_Student',
          component: () =>
            import('../views/Admin/Workbench/Student.vue'),
          meta: {
            title: "工作台 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Workbench/System',
          name: 'Admin_Workbench_System',
          component: () =>
            import('../views/Admin/Workbench/System.vue'),
          meta: {
            title: "工作台 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          招生管理 - 新生批次
        *******************************************************************************************/
        {
          path: '/Admin/RecruitStudents/Batch/Index',
          name: 'Admin_RecruitStudents_Batch_Index',
          component: () =>
            import('../views/Admin/RecruitStudents/Batch/Index.vue'),
          meta: {
            title: "新生批次 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          招生管理 - 学生管理
        *******************************************************************************************/
        {
          path: '/Admin/RecruitStudents/StudentManage/Index',
          name: 'Admin_RecruitStudents_StudentManage_Index',
          component: () =>
            import('../views/Admin/RecruitStudents/StudentManage/Index.vue'),
          meta: {
            title: "学生管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/RecruitStudents/StudentManage/Create',
          name: 'Admin_RecruitStudents_StudentManage_Create',
          component: () =>
            import('../views/Admin/RecruitStudents/StudentManage/Update.vue'),
          meta: {
            title: "学生管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/RecruitStudents/StudentManage/Edit/:id',
          name: 'Admin_RecruitStudents_StudentManage_Edit',
          component: () =>
            import('../views/Admin/RecruitStudents/StudentManage/Update.vue'),
          meta: {
            title: "学生管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/RecruitStudents/StudentManage/Detail/:id',
          name: 'Admin_RecruitStudents_StudentManage_Detail',
          component: () =>
            import('../views/Admin/RecruitStudents/StudentManage/Detail.vue'),
          meta: {
            title: "学生管理  - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          招生管理 - 专业管理
        *******************************************************************************************/
        {
          path: '/Admin/RecruitStudents/MajorManager/Index',
          name: 'Admin_RecruitStudents_MajorManager_Index',
          component: () =>
            import('../views/Admin/RecruitStudents/MajorManager/Index.vue'),
          meta: {
            title: "专业管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/RecruitStudents/MajorManager/Create',
          name: 'Admin_RecruitStudents_MajorManager_Create',
          component: () =>
            import('../views/Admin/RecruitStudents/MajorManager/Update.vue'),
          meta: {
            title: "专业管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/RecruitStudents/MajorManager/Edit/:id',
          name: 'Admin_RecruitStudents_MajorManager_Edit',
          component: () =>
            import('../views/Admin/RecruitStudents/MajorManager/Update.vue'),
          meta: {
            title: "专业管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/RecruitStudents/MajorManager/Detail/:id',
          name: 'Admin_RecruitStudents_MajorManager_Detail',
          component: () =>
            import('../views/Admin/RecruitStudents/MajorManager/Detail.vue'),
          meta: {
            title: "专业管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          招生管理 - 统计管理
        *******************************************************************************************/
        {
          path: '/Admin/RecruitStudents/Statistics/Major',
          name: 'Admin_RecruitStudents_Statistics_Major',
          component: () =>
            import('../views/Admin/RecruitStudents/Statistics/Major.vue'),
          meta: {
            title: "统计管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/RecruitStudents/Statistics/Enroll',
          name: 'Admin_RecruitStudents_Statistics_Enroll',
          component: () =>
            import('../views/Admin/RecruitStudents/Statistics/Enroll.vue'),
          meta: {
            title: "统计管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 假期调课
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/Timetable/Holiday',
          name: 'Admin_EducationalAffairs_Timetable_Holiday',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/Holiday.vue'),
          meta: {
            title: "假期调课 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 自动排课
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/Automation/Index',
          name: 'Admin_EducationalAffairs_Automation_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/Automation/Index.vue'),
          meta: {
            title: "自动排课 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 课程管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/Curriculum/Index',
          name: 'Admin_EducationalAffairs_Curriculum_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/Curriculum/Index.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Curriculum/Details/:Id',
          name: 'Admin_EducationalAffairs_Curriculum_Details',
          component: () =>
            import('../views/Admin/EducationalAffairs/Curriculum/Details.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Curriculum/Create',
          name: 'Admin_EducationalAffairs_Curriculum_Create',
          component: () =>
            import('../views/Admin/EducationalAffairs/Curriculum/Update.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 教学楼设置
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/BasicInfo/ClassBuilding',
          name: 'Admin_EducationalAffairs_BasicInfo_ClassBuilding',
          component: () =>
            import('../views/Admin/EducationalAffairs/BasicInfo/ClassBuilding.vue'),
          meta: {
            title: "教学楼设置 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          教务管理 - 课程表设置
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/BasicInfo/ClassScheduleSet',
          name: 'Admin_EducationalAffairs_BasicInfo_ClassScheduleSet',
          component: () =>
            import('../views/Admin/EducationalAffairs/BasicInfo/ClassScheduleSet.vue'),
          meta: {
            title: "排课条件设置 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          教务管理 - 排课管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/Schedule/Update',
          name: 'Admin_EducationalAffairs_Schedule_Update',
          component: () =>
            import('../views/Admin/EducationalAffairs/Schedule/Update.vue'),
          meta: {
            title: "固定课设置 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教务管理 - 选课管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/ElectiveCourses/Index',
          name: 'Admin_EducationalAffairs_ElectiveCourses_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/ElectiveCourses/Index.vue'),
          meta: {
            title: "选课管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ElectiveCourses/Create',
          name: 'Admin_EducationalAffairs_ElectiveCourses_Create',
          component: () =>
            import('../views/Admin/EducationalAffairs/ElectiveCourses/Update.vue'),
          meta: {
            title: "选课管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ElectiveCourses/Edit/:Id',
          name: 'Admin_EducationalAffairs_ElectiveCourses_Edit',
          component: () =>
            import('../views/Admin/EducationalAffairs/ElectiveCourses/Update.vue'),
          meta: {
            title: "选课管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ElectiveCourses/Details/:Id',
          name: 'Admin_EducationalAffairs_ElectiveCourses_Details',
          component: () =>
            import('../views/Admin/EducationalAffairs/ElectiveCourses/Deatils.vue'),
          meta: {
            title: "选课管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 教学计划
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/Plan/Index',
          name: 'Admin_EducationalAffairs_Plan_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/Plan/Index.vue'),
          meta: {
            title: "教学计划管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Plan/Create',
          name: 'Admin_EducationalAffairs_Plan_Create',
          component: () =>
            import('../views/Admin/EducationalAffairs/Plan/Update.vue'),
          meta: {
            title: "教学计划管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Plan/Edit/:Id',
          name: 'Admin_EducationalAffairs_Plan_Edit',
          component: () =>
            import('../views/Admin/EducationalAffairs/Plan/Update.vue'),
          meta: {
            title: "教学计划管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Plan/Details/:Id',
          name: 'Admin_EducationalAffairs_Plan_Details',
          component: () =>
            import('../views/Admin/EducationalAffairs/Plan/Details.vue'),
          meta: {
            title: "教学计划管理 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教务管理 - 在线考试管理 - 题库管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/ExamMGT/Storehouse/Index',
          name: 'Admin_EducationalAffairs_ExamMGT_Storehouse_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/Storehouse/Index.vue'),
          meta: {
            title: "题库管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/Storehouse/Create',
          name: 'Admin_EducationalAffairs_ExamMGT_Storehouse_Create',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/Storehouse/Update.vue'),
          meta: {
            title: "题库管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/Storehouse/Edit/:Id',
          name: 'Admin_EducationalAffairs_ExamMGT_Storehouse_Edit',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/Storehouse/Update.vue'),
          meta: {
            title: "题库管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/Storehouse/Details/:Id',
          name: 'Admin_EducationalAffairs_ExamMGT_Storehouse_Details',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/Storehouse/Details.vue'),
          meta: {
            title: "题库管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 在线考试管理 - 题目管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/ExamMGT/Question/Index/:bankId',
          name: 'Admin_EducationalAffairs_ExamMGT_Question_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/Question/Index.vue'),
          meta: {
            title: "题目管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 在线考试管理 - 考试管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/ExamMGT/TestPaper/Index',
          name: 'Admin_EducationalAffairs_ExamMGT_TestPaper_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/TestPaper/Index.vue'),
          meta: {
            title: "考试管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        { //任课老师权限路由
          path: '/Admin/MyEducationalAffairs/ExamMGT/TestPaper/Index',
          name: 'Admin_MyEducationalAffairs_ExamMGT_TestPaper_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/TestPaper/Index.vue'),
          meta: {
            title: "考试管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/TestPaper/Edit/:Id', // 新建试卷
          name: 'Admin_EducationalAffairs_ExamMGT_TestPaper_Edit',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/TestPaper/BaseInfo.vue'),
          meta: {
            title: "考试管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/TestPaper/BaseInfo', // 新建试卷
          name: 'Admin_EducationalAffairs_ExamMGT_TestPaper_BaseInfo',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/TestPaper/BaseInfo.vue'),
          meta: {
            title: "考试管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/TestPaper/Auto/:Id', // 系統创建题目
          name: 'Admin_EducationalAffairs_ExamMGT_TestPaper_Auto',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/TestPaper/Auto.vue'),
          meta: {
            title: "考试管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/TestPaper/Preview/:Id', // 试卷预览
          name: 'Admin_EducationalAffairs_ExamMGT_TestPaper_Preview',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/TestPaper/Preview.vue'),
          meta: {
            title: "考试管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/TestPaper/Details/:Id', // 试卷预览
          name: 'Admin_EducationalAffairs_ExamMGT_TestPaper_Details',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/TestPaper/Details.vue'),
          meta: {
            title: "考试管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/ExamMGT/TestPaper/Member/:Id', // 试卷预览
          name: 'Admin_EducationalAffairs_ExamMGT_TestPaper_Member',
          component: () =>
            import('../views/Admin/EducationalAffairs/ExamMGT/TestPaper/Member.vue'),
          meta: {
            title: "考试管理 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教务管理 - 教室信息管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/BasicInfo/ClassRoom',
          name: 'Admin_EducationalAffairs_BasicInfo_ClassRoom',
          component: () =>
            import('../views/Admin/EducationalAffairs/BasicInfo/ClassRoom.vue'),
          meta: {
            title: "教室信息管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 学期教师配置
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/BasicInfo/TeacherConfig',
          name: 'Admin_EducationalAffairs_BasicInfo_TeacherConfig',
          component: () =>
            import('../views/Admin/EducationalAffairs/BasicInfo/TeacherConfig.vue'),
          meta: {
            title: "教师排课条件设置 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 课表管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/Timetable/Record',
          name: 'Admin_EducationalAffairs_Timetable_Record',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/Record.vue'),
          meta: {
            title: "课表调整记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Timetable/Details/:Id',
          name: 'Admin_EducationalAffairs_Timetable_Details',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/Details.vue'),
          meta: {
            title: "课表调整记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Timetable/Curriculum',
          name: 'Admin_EducationalAffairs_Timetable_Curriculum',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/Curriculum.vue'),
          meta: {
            title: "总课表 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Timetable/After',
          name: 'Admin_EducationalAffairs_Timetable_After',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/After.vue'),
          meta: {
            title: "周课表 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Timetable/BeforeIndex',
          name: 'Admin_EducationalAffairs_Timetable_BeforeIndex',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/BeforeIndex.vue'),
          meta: {
            title: "排课调整 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Timetable/WeekTeacherIndex',
          name: 'Admin_EducationalAffairs_Timetable_WeekTeacherIndex',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/TeacherIndex.vue'),
          meta: {
            title: "课表管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Timetable/TeacherIndex',
          name: 'Admin_EducationalAffairs_Timetable_TeacherIndex',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/TeacherIndex.vue'),
          meta: {
            title: "课表管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Timetable/WeekClassIndex',
          name: 'Admin_EducationalAffairs_Timetable_WeekClassIndex',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/ClassIndex.vue'),
          meta: {
            title: "课表管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/Timetable/ClassIndex',
          name: 'Admin_EducationalAffairs_Timetable_ClassIndex',
          component: () =>
            import('../views/Admin/EducationalAffairs/Timetable/ClassIndex.vue'),
          meta: {
            title: "课表管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教务管理 - 课程管理
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/BaseCourse/Index',
          name: 'Admin_EducationalAffairs_BaseCourse_Index',
          component: () =>
            import('../views/Admin/EducationalAffairs/BaseCourse/Index.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/BaseCourse/Create',
          name: 'Admin_EducationalAffairs_BaseCourse_Create',
          component: () =>
            import('../views/Admin/EducationalAffairs/BaseCourse/Update.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/BaseCourse/Edit/:Id',
          name: 'Admin_EducationalAffairs_BaseCourse_Edit',
          component: () =>
            import('../views/Admin/EducationalAffairs/BaseCourse/Update.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/EducationalAffairs/BaseCourse/Details/:Id',
          name: 'Admin_EducationalAffairs_BaseCourse_Details',
          component: () =>
            import('../views/Admin/EducationalAffairs/BaseCourse/Details.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          教务管理 - 课程类型配置
        *******************************************************************************************/
        {
          path: '/Admin/EducationalAffairs/BasicInfo/CourseType',
          name: 'Admin_EducationalAffairs_BasicInfo_CourseType',
          component: () =>
            import('../views/Admin/EducationalAffairs/BasicInfo/CourseType.vue'),
          meta: {
            title: "课程类型配置 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教师薪酬管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/SalaryMGT/Index',
          name: 'Admin_HRManagement_SalaryMGT_Index',
          component: () =>
            import('../views/Admin/HRManagement/SalaryMGT/Index.vue'),
          meta: {
            title: "教师薪酬管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/SalaryMGT/Default/:Id',
          name: 'Admin_HRManagement_SalaryMGT_Default',
          component: () =>
            import('../views/Admin/HRManagement/SalaryMGT/Default.vue'),
          meta: {
            title: "教师薪酬管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/SalaryMGT/MySalary',
          name: 'Admin_HRManagement_SalaryMGT_MySalary',
          component: () =>
            import('../views/Admin/HRManagement/SalaryMGT/MySalary.vue'),
          meta: {
            title: "教师薪酬信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/SalaryMGT/Create',
          name: 'Admin_HRManagement_SalaryMGT_Create',
          component: () =>
            import('../views/Admin/HRManagement/SalaryMGT/Update.vue'),
          meta: {
            title: "教师薪酬信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/SalaryMGT/Edit/:Id',
          name: 'Admin_HRManagement_SalaryMGT_Edit',
          component: () =>
            import('../views/Admin/HRManagement/SalaryMGT/Update.vue'),
          meta: {
            title: "教师薪酬信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/SalaryMGT/Statistics',
          name: 'Admin_HRManagement_SalaryMGT_Statistics',
          component: () =>
            import('../views/Admin/HRManagement/SalaryMGT/Statistics.vue'),
          meta: {
            title: "教师薪酬信息 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          教师论文管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/PaperMGT/Index',
          name: 'Admin_HRManagement_PaperMGT_Index',
          component: () =>
            import('../views/Admin/HRManagement/PaperMGT/Index.vue'),
          meta: {
            title: "教师论文管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/PaperMGT/Audit/:Id',
          name: 'Admin_HRManagement_PaperMGT_Audit',
          component: () =>
            import('../views/Admin/HRManagement/PaperMGT/Default.vue'),
          meta: {
            title: "教师论文管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/PaperMGT/Default/:Id',
          name: 'Admin_HRManagement_PaperMGT_Default',
          component: () =>
            import('../views/Admin/HRManagement/PaperMGT/Default.vue'),
          meta: {
            title: "教师论文管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/PaperMGT/MyPaper',
          name: 'Admin_HRManagement_PaperMGT_MyPaper',
          component: () =>
            import('../views/Admin/HRManagement/PaperMGT/MyPaper.vue'),
          meta: {
            title: "教师论文信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/PaperMGT/MyCreate',
          name: 'Admin_HRManagement_PaperMGT_MyCreate',
          component: () =>
            import('../views/Admin/HRManagement/PaperMGT/Update.vue'),
          meta: {
            title: "教师论文信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/PaperMGT/MyEdit/:Id',
          name: 'Admin_HRManagement_PaperMGT_MyEdit',
          component: () =>
            import('../views/Admin/HRManagement/PaperMGT/Update.vue'),
          meta: {
            title: "教师论文信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/PaperMGT/MyDefault/:Id',
          name: 'Admin_HRManagement_PaperMGT_MyDefault',
          component: () =>
            import('../views/Admin/HRManagement/PaperMGT/Default.vue'),
          meta: {
            title: "教师论文信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教师处分管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/Punish/Index',
          name: 'Admin_HRManagement_Punish_Index',
          component: () =>
            import('../views/Admin/HRManagement/Punish/Index.vue'),
          meta: {
            title: "教师处分管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Punish/Create',
          name: 'Admin_HRManagement_Punish_Create',
          component: () =>
            import('../views/Admin/HRManagement/Punish/Update.vue'),
          meta: {
            title: "教师处分管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Punish/Edit/:Id',
          name: 'Admin_HRManagement_Punish_Edit',
          component: () =>
            import('../views/Admin/HRManagement/Punish/Update.vue'),
          meta: {
            title: "教师处分管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Punish/Default/:Id',
          name: 'Admin_HRManagement_Punish_Default',
          component: () =>
            import('../views/Admin/HRManagement/Punish/Default.vue'),
          meta: {
            title: "教师处分管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Punish/MyPunish',
          name: 'Admin_HRManagement_Punish_MyPunish',
          component: () =>
            import('../views/Admin/HRManagement/Punish/MyPunish.vue'),
          meta: {
            title: "教师处分信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Punish/MyDefault/:Id',
          name: 'Admin_HRManagement_Punish_MyDefault',
          component: () =>
            import('../views/Admin/HRManagement/Punish/Default.vue'),
          meta: {
            title: "教师处分信息 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教师奖励管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/Award/Index',
          name: 'Admin_HRManagement_Award_Index',
          component: () =>
            import('../views/Admin/HRManagement/Award/Index.vue'),
          meta: {
            title: "教师奖励管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Award/Create',
          name: 'Admin_HRManagement_Award_Create',
          component: () =>
            import('../views/Admin/HRManagement/Award/Update.vue'),
          meta: {
            title: "教师奖励管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Award/Edit/:Id',
          name: 'Admin_HRManagement_Award_Edit',
          component: () =>
            import('../views/Admin/HRManagement/Award/Update.vue'),
          meta: {
            title: "教师奖励管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Award/Default/:Id',
          name: 'Admin_HRManagement_Award_Default',
          component: () =>
            import('../views/Admin/HRManagement/Award/Default.vue'),
          meta: {
            title: "教师奖励管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Award/MyAward',
          name: 'Admin_HRManagement_Award_MyAward',
          component: () =>
            import('../views/Admin/HRManagement/Award/MyAward.vue'),
          meta: {
            title: "教师奖励信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Award/MyDefault/:Id',
          name: 'Admin_HRManagement_Award_MyDefault',
          component: () =>
            import('../views/Admin/HRManagement/Award/Default.vue'),
          meta: {
            title: "教师奖励信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教师档案管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/Archives/Index',
          name: 'Admin_HRManagement_Archives_Index',
          component: () =>
            import('../views/Admin/HRManagement/Archives/Index.vue'),
          meta: {
            title: "教师档案管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Archives/Default/:Id',
          name: 'Admin_HRManagement_Archives_Default',
          component: () =>
            import('../views/Admin/HRManagement/Archives/Default.vue'),
          meta: {
            title: "教师档案管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Archives/MyArchives',
          name: 'Admin_HRManagement_Archives_MyArchives',
          component: () =>
            import('../views/Admin/HRManagement/Archives/MyArchives.vue'),
          meta: {
            title: "教师档案信息 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教师考核量化评分汇总表
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/Summary/Index',
          name: 'Admin_HRManagement_Summary_Index',
          component: () =>
            import('../views/Admin/HRManagement/Summary/Index.vue'),
          meta: {
            title: "教师考核量化评分汇总表 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/Summary/Default/:Id',
          name: 'Admin_HRManagement_Summary_Default',
          component: () =>
            import('../views/Admin/HRManagement/Summary/Default.vue'),
          meta: {
            title: "教师考核量化评分汇总表 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教师审核评价
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/ReviewAssessment/Create',
          name: 'Admin_HRManagement_ReviewAssessment_Create',
          component: () =>
            import('../views/Admin/HRManagement/ReviewAssessment/Update.vue'),
          meta: {
            title: "教师考核管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/ReviewAssessment/Edit/:Id',
          name: 'Admin_HRManagement_ReviewAssessment_Edit',
          component: () =>
            import('../views/Admin/HRManagement/ReviewAssessment/Update.vue'),
          meta: {
            title: "教师考核管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/ReviewAssessment/Default/:Id',
          name: 'Admin_HRManagement_ReviewAssessment_Default',
          component: () =>
            import('../views/Admin/HRManagement/ReviewAssessment/Default.vue'),
          meta: {
            title: "教师考核管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/ReviewAssessment/Index',
          name: 'Admin_HRManagement_ReviewAssessment_Index',
          component: () =>
            import('../views/Admin/HRManagement/ReviewAssessment/Index.vue'),
          meta: {
            title: "教师考核管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/ReviewAssessment/List/:Type',
          name: 'Admin_HRManagement_ReviewAssessment_List',
          component: () =>
            import('../views/Admin/HRManagement/ReviewAssessment/List.vue'),
          meta: {
            title: "教师考核管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        // {
        //   path: '/Admin/HRManagement/ReviewAssessment/Index/:Type',
        //   name: 'Admin_HRManagement_ReviewAssessment_Index',
        //   component: () =>
        //     import('../views/Admin/HRManagement/ReviewAssessment/Index.vue'),
        //   meta: {
        //     title: "教师考核管理"
        //   },
        // },

        /******************************************************************************************
          教师自评
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/SelfEvaluation/Index/:Type/:Id',
          name: 'Admin_HRManagement_SelfEvaluation_Index',
          component: () =>
            import('../views/Admin/HRManagement/SelfEvaluation/Index.vue'),
          meta: {
            title: "教师考核管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/SelfEvaluation/MyEvaluation',
          name: 'Admin_HRManagement_SelfEvaluation_MyEvaluation',
          component: () =>
            import('../views/Admin/HRManagement/SelfEvaluation/MyEvaluation.vue'),
          meta: {
            title: "教师考核管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/SelfEvaluation/Default/:Id',
          name: 'Admin_HRManagement_SelfEvaluation_Default',
          component: () =>
            import('../views/Admin/HRManagement/SelfEvaluation/Default.vue'),
          meta: {
            title: "教师考核管理 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          教师考核配置
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/BasicInfo/Evaluation',
          name: 'Admin_GroupNotification_BasicInfo_Evaluation',
          component: () =>
            import('../views/Admin/HRManagement/BasicInfo/Evaluation.vue'),
          meta: {
            title: "教师考核配置 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          教师课时津贴配置
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/BasicInfo/Allowance',
          name: 'Admin_GroupNotification_BasicInfo_Allowance',
          component: () =>
            import('../views/Admin/HRManagement/BasicInfo/Allowance.vue'),
          meta: {
            title: "教师课时津贴配置 - " + webTitleName() + " - " + schoolName()
          },
        },



        /******************************************************************************************
          教师培训管理
        *******************************************************************************************/

        {
          path: '/Admin/HRManagement/TrainingMGT/Index',
          name: 'Admin_GroupNotification_TrainingMGT_Index',
          component: () =>
            import('../views/Admin/HRManagement/TrainingMGT/Index.vue'),
          meta: {
            title: "教师培训管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/TrainingMGT/Edit/:Id',
          name: 'Admin_GroupNotification_TrainingMGT_Edit',
          component: () =>
            import('../views/Admin/HRManagement/TrainingMGT/Update.vue'),
          meta: {
            title: "教师培训管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/TrainingMGT/Create',
          name: 'Admin_GroupNotification_TrainingMGT_Create',
          component: () =>
            import('../views/Admin/HRManagement/TrainingMGT/Update.vue'),
          meta: {
            title: "教师培训管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/TrainingMGT/Default/:Id',
          name: 'Admin_GroupNotification_TrainingMGT_Default',
          component: () =>
            import('../views/Admin/HRManagement/TrainingMGT/Default.vue'),
          meta: {
            title: "教师培训管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 我的培训信息
          path: '/Admin/HRManagement/TrainingMGT/MyTrain',
          name: 'Admin_GroupNotification_TrainingMGT_MyTrain',
          component: () =>
            import('../views/Admin/HRManagement/TrainingMGT/MyTrain.vue'),
          meta: {
            title: "教师培训信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 我的培训信息
          path: '/Admin/HRManagement/TrainingMGT/MyDefault/:Id',
          name: 'Admin_GroupNotification_TrainingMGT_MyDefault',
          component: () =>
            import('../views/Admin/HRManagement/TrainingMGT/Default.vue'),
          meta: {
            title: "教师培训信息 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教师职称管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/BasicInfo/JobTitle',
          name: 'Admin_GroupNotification_BasicInfo_JobTitle',
          component: () =>
            import('../views/Admin/HRManagement/BasicInfo/JobTitle.vue'),
          meta: {
            title: "教师职称管理 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          教师职务管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/BasicInfo/Position',
          name: 'Admin_GroupNotification_BasicInfo_Position',
          component: () =>
            import('../views/Admin/HRManagement/BasicInfo/Position.vue'),
          meta: {
            title: "教师职务管理 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教师信息管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/TeacherInfoMGT/Index',
          name: 'Admin_GroupNotification_TeacherInfoMGT_Index',
          component: () =>
            import('../views/Admin/HRManagement/TeacherInfoMGT/Index.vue'),
          meta: {
            title: "教师信息管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/TeacherInfoMGT/Create',
          name: 'Admin_GroupNotification_TeacherInfoMGT_Create',
          component: () =>
            import('../views/Admin/HRManagement/TeacherInfoMGT/Update.vue'),
          meta: {
            title: "教师信息管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/TeacherInfoMGT/Edit/:Id',
          name: 'Admin_GroupNotification_TeacherInfoMGT_Edit',
          component: () =>
            import('../views/Admin/HRManagement/TeacherInfoMGT/Update.vue'),
          meta: {
            title: "教师信息管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/TeacherInfoMGT/Default/:Id',
          name: 'Admin_GroupNotification_TeacherInfoMGT_Default',
          component: () =>
            import('../views/Admin/HRManagement/TeacherInfoMGT/Default.vue'),
          meta: {
            title: "教师信息管理 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          教师合同管理
        *******************************************************************************************/
        {
          path: '/Admin/HRManagement/FacultyContractMGT/Index',
          name: 'Admin_GroupNotification_FacultyContractMGT_Index',
          component: () =>
            import('../views/Admin/HRManagement/FacultyContractMGT/Index.vue'),
          meta: {
            title: "教师合同管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/FacultyContractMGT/Create',
          name: 'Admin_GroupNotification_FacultyContractMGT_Create',
          component: () =>
            import('../views/Admin/HRManagement/FacultyContractMGT/Update.vue'),
          meta: {
            title: "教师合同管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/FacultyContractMGT/Edit/:Id',
          name: 'Admin_GroupNotification_FacultyContractMGT_Edit',
          component: () =>
            import('../views/Admin/HRManagement/FacultyContractMGT/Update.vue'),
          meta: {
            title: "教师合同管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/HRManagement/FacultyContractMGT/Default/:Id',
          name: 'Admin_GroupNotification_FacultyContractMGT_Default',
          component: () =>
            import('../views/Admin/HRManagement/FacultyContractMGT/Default.vue'),
          meta: {
            title: "教师合同管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 我的合同信息
          path: '/Admin/HRManagement/FacultyContractMGT/MyContract',
          name: 'Admin_GroupNotification_FacultyContractMGT_MyContract',
          component: () =>
            import('../views/Admin/HRManagement/FacultyContractMGT/MyContract.vue'),
          meta: {
            title: "教师合同信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 我的合同信息
          path: '/Admin/HRManagement/FacultyContractMGT/MyDefault/:Id',
          name: 'Admin_GroupNotification_FacultyContractMGT_MyDefault',
          component: () =>
            import('../views/Admin/HRManagement/FacultyContractMGT/Default.vue'),
          meta: {
            title: "教师合同信息 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          群发通知
        *******************************************************************************************/
        {
          path: '/Admin/GroupNotification/Index',
          name: 'Admin_GroupNotification_Index',
          component: () =>
            import('../views/Admin/GroupNotification/Index.vue'),
          meta: {
            title: "群发通知 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          请假管理
        *******************************************************************************************/
        {
          path: '/Admin/LeaveMGT/Index',
          name: 'Admin_LeaveMGT_Index',
          component: () =>
            import('../views/Admin/LeaveMGT/Index.vue'),
          meta: {
            title: "请假管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/LeaveMGT/Default/:Id',
          name: 'Admin_LeaveMGT_Default',
          component: () =>
            import('../views/Admin/LeaveMGT/Default.vue'),
          meta: {
            title: "请假管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/LeaveMGT/Create',
          name: 'Admin_LeaveMGT_Create',
          component: () =>
            import('../views/Admin/LeaveMGT/Update.vue'),
          meta: {
            title: "请假管理 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          班主任考核
        *******************************************************************************************/
        {
          path: '/Admin/Assessment/Moon/Index',
          name: 'Admin_Assessment_Moon_Index',
          component: () =>
            import('../views/Admin/Assessment/Moon/Index.vue'),
          meta: {
            title: "班主任考核 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Moon/Details/:Id',
          name: 'Admin_Assessment_Moon_Details',
          component: () =>
            import('../views/Admin/Assessment/Moon/Details.vue'),
          meta: {
            title: "班主任考核 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Semester',
          name: 'Admin_Assessment_Semester',
          component: () =>
            import('../views/Admin/Assessment/Semester.vue'),
          meta: {
            title: "班主任考核 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Semester/Index',
          name: 'Admin_Assessment_Semester_Index',
          component: () =>
            import('../views/Admin/Assessment/Semester/Index.vue'),
          meta: {
            title: "班主任考核 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Semester/Details/:Id',
          name: 'Admin_Assessment_Semester_Details',
          component: () =>
            import('../views/Admin/Assessment/Semester/Details.vue'),
          meta: {
            title: "班主任考核 - " + webTitleName() + " - " + schoolName()
          },
        },
        //学年考核
        {
          path: '/Admin/Assessment/AcademicYear/Index',
          name: 'Admin_Assessment_AcademicYear_Index',
          component: () =>
            import('../views/Admin/Assessment/AcademicYear/Index.vue'),
          meta: {
            title: "学年考核"
          }
        },
        {
          path: '/Admin/Assessment/AcademicYear/Details/:Id',
          name: 'Admin_Assessment_AcademicYear_Details',
          component: () =>
            import('../views/Admin/Assessment/AcademicYear/Details.vue'),
          meta: {
            title: "学年考核"
          }
        },
        {
          path: '/Admin/Assessment/AcademicYear/create',
          name: 'Admin_Assessment_AcademicYear_Create',
          component: () =>
            import('../views/Admin/Assessment/AcademicYear/Update.vue'),
          meta: {
            title: "学年考核"
          }
        },
        {
          path: '/Admin/Assessment/AcademicYear/Edit/:id',
          name: 'Admin_Assessment_AcademicYear_Edit',
          component: () =>
            import('../views/Admin/Assessment/AcademicYear/Update.vue'),
          meta: {
            title: "学年考核"
          }
        },
        {
          path: '/Admin/Assessment/Customize',
          name: 'Admin_Assessment_Customize',
          component: () =>
            import('../views/Admin/Assessment/Customize.vue'),
          meta: {
            title: "学年考核 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/PlusMinus',
          name: 'Admin_Assessment_PlusMinus',
          component: () =>
            import('../views/Admin/Assessment/PlusMinus.vue'),
          meta: {
            title: "学年考核 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Routine',
          name: 'Admin_Assessment_Routine',
          component: () =>
            import('../views/Admin/Assessment/Routine.vue'),
          meta: {
            title: "学年考核 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            安全考核奖
        **********************************************************************************/
        {
          path: '/Admin/SafetyAward/Index',
          name: 'Admin_SafetyAward_Index',
          component: () =>
            import('../views/Admin/SafetyAward/Index.vue'),
          meta: {
            title: "安全考核奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        /**
         * 班主任考核管理-------------------------------------------------------------------------------------------------------------
         */
        //自定义考核项目
        //学期考核加减分
        {
          path: '/Admin/Assessment/Semester/PlusMinus/Index',
          name: 'Admin_Assessment_Semester_PlusMinus_Index',
          component: () =>
            import('../views/Admin/Assessment/Semester/PlusMinus/Index.vue'),
          meta: {
            title: "学期考核加减分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Semester/PlusMinus/Create',
          name: 'Admin_Assessment_Semester_PlusMinus_Create',
          component: () =>
            import('../views/Admin/Assessment/Semester/PlusMinus/Update.vue'),
          meta: {
            title: "学期考核加减分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Semester/PlusMinus/Edit/:Id',
          name: 'Admin_Assessment_Semester_PlusMinus_Edit',
          component: () =>
            import('../views/Admin/Assessment/Semester/PlusMinus/Update.vue'),
          meta: {
            title: "学期考核加减分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Semester/PlusMinus/Details/:Id',
          name: 'Admin_Assessment_Semester_PlusMinus_Details',
          component: () =>
            import('../views/Admin/Assessment/Semester/PlusMinus/Details.vue'),
          meta: {
            title: "学期考核加减分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/ReView/Index',
          name: 'Admin_Assessment_AcademicYear_ReView',
          component: () =>
            import('../views/Admin/Assessment/ReView.vue'),
          meta: {
            title: "学期考核加减分"
          }
        },
        // 月考核常规项
        {
          path: '/Admin/Assessment/Routine/Index',
          name: 'Admin_Assessment_Routine_Index',
          component: () =>
            import('../views/Admin/Assessment/Routine/Index.vue'),
          meta: {
            title: "月考核常规项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Routine/Create',
          name: 'Admin_Assessment_Routine_Create',
          component: () =>
            import('../views/Admin/Assessment/Routine/Update.vue'),
          meta: {
            title: "月考核常规项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Routine/Edit/:Id',
          name: 'Admin_Assessment_Routine_Edit',
          component: () =>
            import('../views/Admin/Assessment/Routine/Update.vue'),
          meta: {
            title: "月考核常规项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Routine/Details/:Id',
          name: 'Admin_Assessment_Routine_Details',
          component: () =>
            import('../views/Admin/Assessment/Routine/Details.vue'),
          meta: {
            title: "月考核常规项 - " + webTitleName() + " - " + schoolName()
          },
        },
        // 自定义项目
        {
          path: '/Admin/Assessment/Customize/Index',
          name: 'Admin_Assessment_Customize_Index',
          component: () =>
            import('../views/Admin/Assessment/Customize/Index.vue'),
          meta: {
            title: "月考核常规项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Customize/Details/:Id',
          name: 'Admin_Assessment_Customize_Details',
          component: () =>
            import('../views/Admin/Assessment/Customize/Details.vue'),
          meta: {
            title: "月考核常规项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Customize/Create',
          name: 'Admin_Assessment_Customize_Create',
          component: () =>
            import('../views/Admin/Assessment/Customize/Update.vue'),
          meta: {
            title: "月考核常规项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/Customize/Edit/:Id',
          name: 'Admin_Assessment_Customize_Edit',
          component: () =>
            import('../views/Admin/Assessment/Customize/Update.vue'),
          meta: {
            title: "月考核常规项 - " + webTitleName() + " - " + schoolName()
          },
        },
        // 月考核加减分项
        {
          path: '/Admin/Assessment/PlusMinus/Index',
          name: 'Admin_Assessment_PlusMinus_Index',
          component: () =>
            import('../views/Admin/Assessment/PlusMinus/Index.vue'),
          meta: {
            title: "月考核加减分项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/PlusMinus/Details/:Id',
          name: 'Admin_Assessment_PlusMinus_Details',
          component: () =>
            import('../views/Admin/Assessment/PlusMinus/Details.vue'),
          meta: {
            title: "月考核加减分项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/PlusMinus/Create',
          name: 'Admin_Assessment_PlusMinus_Create',
          component: () =>
            import('../views/Admin/Assessment/PlusMinus/Update.vue'),
          meta: {
            title: "月考核加减分项 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Assessment/PlusMinus/Edit/:Id',
          name: 'Admin_Assessment_PlusMinus_Edit',
          component: () =>
            import('../views/Admin/Assessment/PlusMinus/Update.vue'),
          meta: {
            title: "月考核加减分项 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            奖学金管理
        **********************************************************************************/
        {
          path: '/Admin/ScholarshipMGT/Batch/Index',
          name: 'Admin_ScholarshipMGT_Batch_Index',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Batch/Index.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Batch/Create',
          name: 'Admin_ScholarshipMGT_Batch_Create',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Batch/Update.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Batch/Edit/:Id',
          name: 'Admin_ScholarshipMGT_Batch_Edit',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Batch/Update.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Batch/Details/:Id',
          name: 'Admin_ScholarshipMGT_Batch_Details',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Batch/Details.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Roster/Index/:Id',
          name: 'Admin_ScholarshipMGT_Roster_Index',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Roster/Index.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Roster/Details/:Id',
          name: 'Admin_ScholarshipMGT_Roster_Details',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Roster/Details.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Info/Index/:Id',
          name: 'Admin_ScholarshipMGT_Info_Index',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Info/Index.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Info/Details/:Id',
          name: 'Admin_ScholarshipMGT_Info_Details',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Info/Details.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Audit/Index',
          name: 'Admin_ScholarshipMGT_Audit_Index',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Audit/Index.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ScholarshipMGT/Audit/Details/:Id',
          name: 'Admin_ScholarshipMGT_Audit_Details',
          component: () =>
            import('../views/Admin/ScholarshipMGT/Audit/Details.vue'),
          meta: {
            title: "奖学金管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            学生会管理
        **********************************************************************************/
        {
          path: '/Admin/StudentUnion/Index',
          name: 'Admin_StudentUnion_Index',
          component: () =>
            import('../views/Admin/StudentUnion/Index.vue'),
          meta: {
            title: "学生会管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/StudentUnion/Details/:Id',
          name: 'Admin_StudentUnion_Details',
          component: () =>
            import('../views/Admin/StudentUnion/Details.vue'),
          meta: {
            title: "学生会管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            德育学分
        **********************************************************************************/
        {
          path: '/Admin/MoralEducation/Index',
          name: 'Admin_MoralEducation_Index',
          component: () =>
            import('../views/Admin/MoralEducation/Index.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/MoralEducation/Index2',
          name: 'Admin_MoralEducation_Index2',
          component: () =>
            import('../views/Admin/MoralEducation/Index2.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/MoralEducation/Details/:Id',
          name: 'Admin_MoralEducation_Details',
          component: () =>
            import('../views/Admin/MoralEducation/Details.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/MoralEducation/Details2/:Id',
          name: 'Admin_MoralEducation_Details2',
          component: () =>
            import('../views/Admin/MoralEducation/Details2.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/MoralEducation/Create',
          name: 'Admin_MoralEducation_Create',
          component: () =>
            import('../views/Admin/MoralEducation/Update.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/MoralEducation/Create2',
          name: 'Admin_MoralEducation_Create2',
          component: () =>
            import('../views/Admin/MoralEducation/Update2.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/MoralEducation/Edit/:Id',
          name: 'Admin_MoralEducation_Edit',
          component: () =>
            import('../views/Admin/MoralEducation/Update.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/MoralEducation/Evaluation',
          name: 'Admin_MoralEducation_Evaluation',
          component: () =>
            import('../views/Admin/MoralEducation/Evaluation.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },

        /*********************************************************************************
            总评配置
        **********************************************************************************/
        {
          //列表
          path: '/Admin/EvaluationConfig/Index',
          name: 'Admin_EvaluationConfig_Index',
          component: () =>
            import('../views/Admin/EvaluationConfig/Index.vue'),
          meta: {
            title: "总评配置 - " + webTitleName() + " - " + schoolName()
          },
        },

        {
          //新增
          path: '/Admin/EvaluationConfig/Create',
          name: 'Admin_EvaluationConfig_Create',
          component: () =>
            import('../views/Admin/EvaluationConfig/Update.vue'),
          meta: {
            title: "总评配置 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/EvaluationConfig/Update/:id',
          name: 'Admin_EvaluationConfig_Update',
          component: () =>
            import('../views/Admin/EvaluationConfig/Update.vue'),
          meta: {
            title: "总评配置 - " + webTitleName() + " - " + schoolName()
          },
        },


        /*********************************************************************************
            素养之星配置
        **********************************************************************************/
        {
          //列表
          path: '/Admin/LiteracyStarConfig/Index',
          name: 'Admin_LiteracyStarConfig_Index',
          component: () =>
            import('../views/Admin/LiteracyStarConfig/Index.vue'),
          meta: {
            title: "素养之星配置 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/LiteracyStarConfig/Create',
          name: 'Admin_LiteracyStarConfig_Create',
          component: () =>
            import('../views/Admin/LiteracyStarConfig/Update.vue'),
          meta: {
            title: "素养之星配置 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/LiteracyStarConfig/Update/:id',
          name: 'Admin_LiteracyStarConfig_Update',
          component: () =>
            import('../views/Admin/LiteracyStarConfig/Update.vue'),
          meta: {
            title: "素养之星配置 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            素养之星
        **********************************************************************************/
        {
          //列表
          path: '/Admin/LiteracyStar/Index',
          name: 'Admin_LiteracyStar_Index',
          component: () =>
            import('../views/Admin/LiteracyStar/Index.vue'),
          meta: {
            title: "素养之星 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //评比
          path: '/Admin/LiteracyStar/Default',
          name: 'Admin_LiteracyStar_Default',
          component: () =>
            import('../views/Admin/LiteracyStar/Default.vue'),
          meta: {
            title: "素养之星 - " + webTitleName() + " - " + schoolName()
          },
        },



        /*********************************************************************************
            准备工作 Preparations
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Preparations/Index',
          name: 'Admin_Preparations_Index',
          component: () =>
            import('../views/Admin/Preparations/Index.vue'),
          meta: {
            title: "系統部署步骤 - " + webTitleName() + " - " + schoolName()
          },
        },
        // 人事
        {
          //列表
          path: '/Admin/Preparations/managementIndex',
          name: 'Admin_Preparations_managementIndex',
          component: () =>
            import('../views/Admin/Preparations/managementIndex.vue'),
          meta: {
            title: "系統部署步骤 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //列表
          path: '/Admin/Academictransform/Index',
          name: 'Admin_Academictransform_Index',
          component: () =>
            import('../views/Admin/Academictransform/Index.vue'),
          meta: {
            title: "系統部署步骤 - " + webTitleName() + " - " + schoolName()
          },
        },




        /*********************************************************************************
            社员职务
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Club/ClubPosition/Index',
          name: 'Admin_Club_ClubPosition_Index',
          component: () =>
            import('../views/Admin/Club/ClubPosition/Index.vue'),
          meta: {
            title: "社员职务 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            社团信息
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Club/ClubMGMT/Index',
          name: 'Admin_Club_ClubMGMT_Index',
          component: () =>
            import('../views/Admin/Club/ClubMGMT/Index.vue'),
          meta: {
            title: "社团信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Club/ClubMGMT/Create',
          name: 'Admin_Club_ClubMGMT_Create',
          component: () =>
            import('../views/Admin/Club/ClubMGMT/Update.vue'),
          meta: {
            title: "社团信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Club/ClubMGMT/Edit/:Id',
          name: 'Admin_Club_ClubMGMT_Edit',
          component: () =>
            import('../views/Admin/Club/ClubMGMT/Update.vue'),
          meta: {
            title: "社团信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //详情
          path: '/Admin/Club/ClubMGMT/Details/:Id',
          name: 'Admin_Club_ClubMGMT_Details',
          component: () =>
            import('../views/Admin/Club/ClubMGMT/Details.vue'),
          meta: {
            title: "社团信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            社团活动
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Club/ClubActivities/Index',
          name: 'Admin_Club_ClubActivities_Index',
          component: () =>
            import('../views/Admin/Club/ClubActivities/Index.vue'),
          meta: {
            title: "社团活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //列表
          path: '/Admin/Club/MyClubActivities/Index/:type',
          name: 'Admin_Club_MyClubActivities_Index',
          component: () =>
            import('../views/Admin/Club/ClubActivities/Index.vue'),
          meta: {
            title: "社团活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //列表
          path: '/Admin/Club/ClubActivities/Details/:Id',
          name: 'Admin_Club_ClubActivities_Details',
          component: () =>
            import('../views/Admin/Club/ClubActivities/Details.vue'),
          meta: {
            title: "社团活动 - " + webTitleName() + " - " + schoolName()
          },
        },




        /*********************************************************************************
            学生基础信息 Student
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Student/Index',
          name: 'Admin_Student_Index',
          component: () =>
            import('../views/Admin/Student/Index.vue'),
          meta: {
            title: "学生基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //详情
          path: '/Admin/Student/Detail/:id',
          name: 'Admin_Student_Detail',
          component: () =>
            import('../views/Admin/Student/Detail.vue'),
          meta: {
            title: "学生基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 编辑
          path: '/Admin/Student/Edit/:id',
          name: 'Admin_Student_Edit',
          component: () =>
            import('../views/Admin/Student/Edit.vue'),
          meta: {
            title: "学生基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增
          path: '/Admin/Student/Create',
          name: 'Admin_Student_Create',
          component: () =>
            import('../views/Admin/Student/Create.vue'),
          meta: {
            title: "学生基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            素养评价 Growth
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Growth/Index',
          name: 'Admin_Growth_Index',
          component: () =>
            import('../views/Admin/Growth/Index.vue'),
          meta: {
            title: "素养评价 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 详情
          path: '/Admin/Growth/Details/:id',
          name: 'Admin_Growth_Details',
          component: () =>
            import('../views/Admin/Growth/Details.vue'),
          meta: {
            title: "素养评价 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            素养课程 LiteracyCourse
        **********************************************************************************/
        {
          //列表
          path: '/Admin/LiteracyCourse/Index',
          name: 'Admin_LiteracyCourse_Index',
          component: () =>
            import('../views/Admin/LiteracyCourse/Index.vue'),
          meta: {
            title: "素养课程 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增
          path: '/Admin/LiteracyCourse/Create',
          name: 'Admin_LiteracyCourse_Create',
          component: () =>
            import('../views/Admin/LiteracyCourse/Operat.vue'),
          meta: {
            title: "素养课程 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 编辑
          path: '/Admin/LiteracyCourse/Edit/:id',
          name: 'Admin_LiteracyCourse_Edit',
          component: () =>
            import('../views/Admin/LiteracyCourse/Operat.vue'),
          meta: {
            title: "素养课程 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 详情
          path: '/Admin/LiteracyCourse/Details/:id',
          name: 'Admin_LiteracyCourse_Details',
          component: () =>
            import('../views/Admin/LiteracyCourse/Details.vue'),
          meta: {
            title: "素养课程 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            素养课程类型 LiteracyCourseType
        **********************************************************************************/
        {
          //列表
          path: '/Admin/LiteracyCourseType/Index',
          name: 'Admin_LiteracyCourseType_Index',
          component: () =>
            import('../views/Admin/LiteracyCourseType/Index.vue'),
          meta: {
            title: "素养课程类型 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增
          path: '/Admin/LiteracyCourseType/Create',
          name: 'Admin_LiteracyCourseType_Create',
          component: () =>
            import('../views/Admin/LiteracyCourseType/Operat.vue'),
          meta: {
            title: "素养课程类型 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 编辑
          path: '/Admin/LiteracyCourseType/Edit/:id',
          name: 'Admin_LiteracyCourseType_Edit',
          component: () =>
            import('../views/Admin/LiteracyCourseType/Operat.vue'),
          meta: {
            title: "素养课程类型 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 详情
          path: '/Admin/LiteracyCourseType/Details/:id',
          name: 'Admin_LiteracyCourseType_Details',
          component: () =>
            import('../views/Admin/LiteracyCourseType/Details.vue'),
          meta: {
            title: "素养课程类型 - " + webTitleName() + " - " + schoolName()
          },
        },

        /*********************************************************************************
            成长档案
        **********************************************************************************/
        {
          //列表
          path: '/Admin/GrowthArchives/Index',
          name: 'Admin_GrowthArchives_Index',
          component: () =>
            import('../views/Admin/GrowthArchives/Index.vue'),
          meta: {
            title: "成长档案 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //详情
          path: '/Admin/GrowthArchives/Details/:id',
          name: 'Admin_GrowthArchives_Details',
          component: () =>
            import('../views/Admin/GrowthArchives/Details.vue'),
          meta: {
            title: "成长档案 - " + webTitleName() + " - " + schoolName()
          },
        },
        //班主任手册检查
        //班主任手册检查
        {
          //列表
          path: '/Admin/Adviser/ManualInspection/Index',
          name: 'Admin_Adviser_ManualInspection_Index',
          component: () =>
            import('../views/Admin/Adviser/ManualInspection/Index.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //列表
          path: '/Admin/Adviser/ManualInspection/studentPriceDetail/:Id',
          name: 'Admin_Adviser_ManualInspection_StudebtPriceDetail',
          component: () =>
            import('../views/Admin/Adviser/ManualInspection/studentPriceDetail.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //列表
          path: '/Admin/Adviser/ManualInspection/Details/:Id',
          name: 'Admin_Adviser_ManualInspection_Details',
          component: () =>
            import('../views/Admin/Adviser/ManualInspection/Details.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
          学期工作计划
        /**********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/WorkPlan/Index',
          name: 'Admin_Adviser_WorkPlan_Index',
          component: () =>
            import('../views/Admin/Adviser/WorkPlan/Index.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/WorkPlan/Create',
          name: 'Admin_Adviser_WorkPlan_Create',
          component: () =>
            import('../views/Admin/Adviser/WorkPlan/Create.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/WorkPlan/Edit/:Id',
          name: 'Admin_Adviser_WorkPlan_Edit',
          component: () =>
            import('../views/Admin/Adviser/WorkPlan/Create.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
          月工作计划
        /**********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/MonthWorkPlan/Index',
          name: 'Admin_Adviser_MonthWorkPlan_Index',
          component: () =>
            import('../views/Admin/Adviser/MonthWorkPlan/Index.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/MonthWorkPlan/Create',
          name: 'Admin_Adviser_MonthWorkPlan_Create',
          component: () =>
            import('../views/Admin/Adviser/MonthWorkPlan/Create.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/MonthWorkPlan/Edit/:Id',
          name: 'Admin_Adviser_MonthWorkPlan_Edit',
          component: () =>
            import('../views/Admin/Adviser/MonthWorkPlan/Create.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
          班干部会议纪要
        /**********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/ClassCadreMeetingMinute/Index',
          name: 'Admin_Adviser_ClassCadreMeetingMinute_Index',
          component: () =>
            import('../views/Admin/Adviser/ClassCadreMeetingMinute/Index.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/ClassCadreMeetingMinute/Create',
          name: 'Admin_Adviser_ClassCadreMeetingMinute_Create',
          component: () =>
            import('../views/Admin/Adviser/ClassCadreMeetingMinute/Create.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/ClassCadreMeetingMinute/Edit/:Id',
          name: 'Admin_Adviser_ClassCadreMeetingMinute_Edit',
          component: () =>
            import('../views/Admin/Adviser/ClassCadreMeetingMinute/Create.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/ClassCadreMeetingMinute/Details/:Id',
          name: 'Admin_Adviser_ClassCadreMeetingMinute_Details',
          component: () =>
            import('../views/Admin/Adviser/ClassCadreMeetingMinute/Details.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班干部职位管理
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/ClassPosition/Index',
          name: 'Admin_Adviser_ClassPosition_Index',
          component: () =>
            import('../views/Admin/Adviser/ClassPosition/Index.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            学期活动计划
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/ActivityPlan/Index',
          name: 'Admin_Adviser_ActivityPlan_Index',
          component: () =>
            import('../views/Admin/Adviser/ActivityPlan/Index.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/ActivityPlan/Create',
          name: 'Admin_Adviser_ActivityPlan_Create',
          component: () =>
            import('../views/Admin/Adviser/ActivityPlan/Create.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/ActivityPlan/Edit/:Id',
          name: 'Admin_Adviser_ActivityPlan_Edit',
          component: () =>
            import('../views/Admin/Adviser/ActivityPlan/Create.vue'),
          meta: {
            title: "班主任手册 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班级备忘录
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/ClassWorkMemo/Index',
          name: 'Admin_Adviser_ClassWorkMemo_Index',
          component: () =>
            import('../views/Admin/Adviser/ClassWorkMemo/Index.vue'),
          meta: {
            title: "班级备忘录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/ClassWorkMemo/Create',
          name: 'Admin_Adviser_ClassWorkMemo_Create',
          component: () =>
            import('../views/Admin/Adviser/ClassWorkMemo/Create.vue'),
          meta: {
            title: "班级备忘录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/ClassWorkMemo/Edit/:Id',
          name: 'Admin_Adviser_ClassWorkMemo_Edit',
          component: () =>
            import('../views/Admin/Adviser/ClassWorkMemo/Create.vue'),
          meta: {
            title: "班级备忘录 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            主题班会
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/ClassMeeting/Index',
          name: 'Admin_Adviser_ClassMeeting_Index',
          component: () =>
            import('../views/Admin/Adviser/ClassMeeting/Index.vue'),
          meta: {
            title: "主题班会 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/ClassMeeting/Create',
          name: 'Admin_Adviser_ClassMeeting_Create',
          component: () =>
            import('../views/Admin/Adviser/ClassMeeting/Create.vue'),
          meta: {
            title: "主题班会 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/ClassMeeting/Edit/:Id',
          name: 'Admin_Adviser_ClassMeeting_Edit',
          component: () =>
            import('../views/Admin/Adviser/ClassMeeting/Create.vue'),
          meta: {
            title: "主题班会 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/ClassMeeting/Details/:Id',
          name: 'Admin_Adviser_ClassMeeting_Details',
          component: () =>
            import('../views/Admin/Adviser/ClassMeeting/Details.vue'),
          meta: {
            title: "主题班会 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            家长会
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/ContactRecord/Index',
          name: 'Admin_Adviser_ContactRecord_Index',
          component: () =>
            import('../views/Admin/Adviser/ContactRecord/Index.vue'),
          meta: {
            title: "家长会 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/ContactRecord/Create',
          name: 'Admin_Adviser_ContactRecord_Create',
          component: () =>
            import('../views/Admin/Adviser/ContactRecord/Create.vue'),
          meta: {
            title: "家长会 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/ContactRecord/Edit/:Id',
          name: 'Admin_Adviser_ContactRecord_Edit',
          component: () =>
            import('../views/Admin/Adviser/ContactRecord/Create.vue'),
          meta: {
            title: "家长会 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/ContactRecord/Details/:Id',
          name: 'Admin_Adviser_ContactRecord_Details',
          component: () =>
            import('../views/Admin/Adviser/ContactRecord/Details.vue'),
          meta: {
            title: "家长会 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            家校活动记录
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/ParentActivityRecord/Index',
          name: 'Admin_Adviser_ParentActivityRecord_Index',
          component: () =>
            import('../views/Admin/Adviser/ParentActivityRecord/Index.vue'),
          meta: {
            title: "家校活动记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/ParentActivityRecord/Create',
          name: 'Admin_Adviser_ParentActivityRecord_Create',
          component: () =>
            import('../views/Admin/Adviser/ParentActivityRecord/Create.vue'),
          meta: {
            title: "家校活动记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/ParentActivityRecord/Edit/:Id',
          name: 'Admin_Adviser_ParentActivityRecord_Edit',
          component: () =>
            import('../views/Admin/Adviser/ParentActivityRecord/Create.vue'),
          meta: {
            title: "家校活动记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/ParentActivityRecord/Details/:Id',
          name: 'Admin_Adviser_ParentActivityRecord_Details',
          component: () =>
            import('../views/Admin/Adviser/ParentActivityRecord/Details.vue'),
          meta: {
            title: "家校活动记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            学期总结
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/WorkSummary/Index',
          name: 'Admin_Adviser_WorkSummary_Index',
          component: () =>
            import('../views/Admin/Adviser/WorkSummary/Index.vue'),
          meta: {
            title: "学期总结 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/WorkSummary/Create',
          name: 'Admin_Adviser_WorkSummary_Create',
          component: () =>
            import('../views/Admin/Adviser/WorkSummary/Create.vue'),
          meta: {
            title: "学期总结 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/WorkSummary/Edit/:Id',
          name: 'Admin_Adviser_WorkSummary_Edit',
          component: () =>
            import('../views/Admin/Adviser/WorkSummary/Create.vue'),
          meta: {
            title: "学期总结 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            双优生分析
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/DoubleEugenics/Index',
          name: 'Admin_Adviser_DoubleEugenics_Index',
          component: () =>
            import('../views/Admin/Adviser/DoubleEugenics/Index.vue'),
          meta: {
            title: "双优生分析 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/DoubleEugenics/Create',
          name: 'Admin_Adviser_DoubleEugenics_Create',
          component: () =>
            import('../views/Admin/Adviser/DoubleEugenics/Create.vue'),
          meta: {
            title: "双优生分析 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/DoubleEugenics/Edit/:Id',
          name: 'Admin_Adviser_DoubleEugenics_Edit',
          component: () =>
            import('../views/Admin/Adviser/DoubleEugenics/Create.vue'),
          meta: {
            title: "双优生分析 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/DoubleEugenics/Details/:Id',
          name: 'Admin_Adviser_DoubleEugenics_Details',
          component: () =>
            import('../views/Admin/Adviser/DoubleEugenics/Details.vue'),
          meta: {
            title: "双优生分析 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            行为偏常辅导
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/AbnormalBehavior/Index',
          name: 'Admin_Adviser_AbnormalBehavior_Index',
          component: () =>
            import('../views/Admin/Adviser/AbnormalBehavior/Index.vue'),
          meta: {
            title: "行为偏常辅导 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/AbnormalBehavior/Create',
          name: 'Admin_Adviser_AbnormalBehavior_Create',
          component: () =>
            import('../views/Admin/Adviser/AbnormalBehavior/Create.vue'),
          meta: {
            title: "行为偏常辅导 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/AbnormalBehavior/Edit/:Id',
          name: 'Admin_Adviser_AbnormalBehavior_Edit',
          component: () =>
            import('../views/Admin/Adviser/AbnormalBehavior/Create.vue'),
          meta: {
            title: "行为偏常辅导 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/AbnormalBehavior/Details/:Id',
          name: 'Admin_Adviser_AbnormalBehavior_Details',
          component: () =>
            import('../views/Admin/Adviser/AbnormalBehavior/Details.vue'),
          meta: {
            title: "行为偏常辅导 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            特异体质
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/Constitution/TeacherIndex',
          name: 'Admin_Adviser_Constitution_Index',
          component: () =>
            import('../views/Admin/Adviser/Constitution/Index.vue'),
          meta: {
            title: "特异体质学生情况 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //列表
          path: '/Admin/Adviser/Constitution/Index',
          name: 'Admin_Adviser_Constitution_Index',
          component: () =>
            import('../views/Admin/Adviser/Constitution/Index.vue'),
          meta: {
            title: "特异体质学生情况 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //班主任新增
          path: '/Admin/Adviser/Constitution/TeacherCreate',
          name: 'Admin_Adviser_Constitution_TeacherCreate',
          component: () =>
            import('../views/Admin/Adviser/Constitution/Update.vue'),
          meta: {
            title: "特异体质学生情况 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //班主任编辑
          path: '/Admin/Adviser/Constitution/TeacherEdit/:Id',
          name: 'Admin_Adviser_Constitution_TeacherEdit',
          component: () =>
            import('../views/Admin/Adviser/Constitution/Update.vue'),
          meta: {
            title: "特异体质学生情况 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/Constitution/Details/:Id',
          name: 'Admin_Adviser_Constitution_Details',
          component: () =>
            import('../views/Admin/Adviser/Constitution/Details.vue'),
          meta: {
            title: "特异体质学生情况 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            品德评语
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/StudentComment/Index',
          name: 'Admin_Adviser_StudentComment_Index',
          component: () =>
            import('../views/Admin/Adviser/StudentComment/Index.vue'),
          meta: {
            title: "品德评语 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/StudentComment/Create',
          name: 'Admin_Adviser_StudentComment_Create',
          component: () =>
            import('../views/Admin/Adviser/StudentComment/Create.vue'),
          meta: {
            title: "品德评语 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/StudentComment/Edit/:Id',
          name: 'Admin_Adviser_StudentComment_Edit',
          component: () =>
            import('../views/Admin/Adviser/StudentComment/Create.vue'),
          meta: {
            title: "品德评语 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/StudentComment/Details/:Id',
          name: 'Admin_Adviser_StudentComment_Details',
          component: () =>
            import('../views/Admin/Adviser/StudentComment/Details.vue'),
          meta: {
            title: "品德评语 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            个人谈话
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/IndividualEducation/Index',
          name: 'Admin_Adviser_IndividualEducation_Index',
          component: () =>
            import('../views/Admin/Adviser/IndividualEducation/Index.vue'),
          meta: {
            title: "个人谈话 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/IndividualEducation/Create',
          name: 'Admin_Adviser_IndividualEducation_Create',
          component: () =>
            import('../views/Admin/Adviser/IndividualEducation/Create.vue'),
          meta: {
            title: "个人谈话 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/IndividualEducation/Edit/:Id',
          name: 'Admin_Adviser_IndividualEducation_Edit',
          component: () =>
            import('../views/Admin/Adviser/IndividualEducation/Create.vue'),
          meta: {
            title: "个人谈话 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //查看
          path: '/Admin/Adviser/IndividualEducation/Details/:Id',
          name: 'Admin_Adviser_IndividualEducation_Details',
          component: () =>
            import('../views/Admin/Adviser/IndividualEducation/Details.vue'),
          meta: {
            title: "个人谈话 - " + webTitleName() + " - " + schoolName()
          },
        },

        /*********************************************************************************
            成绩管理 Score
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Score/Index',
          name: 'Admin_Score_Index',
          component: () =>
            import('../views/Admin/Score/Index.vue'),
          meta: {
            title: "成绩管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班级成绩 Score
        **********************************************************************************/
        {
          //班级成绩
          path: '/Admin/Score/Adviser',
          name: 'Admin_Score_Adviser',
          component: () =>
            import('../views/Admin/Score/Adviser.vue'),
          meta: {
            title: "班级成绩 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //班级成绩 查看
          path: '/Admin/Score/Detail/:id',
          name: 'Admin_Score_Details',
          component: () =>
            import('../views/Admin/Score/Details.vue'),
          meta: {
            title: "班级成绩 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //班级成绩 编辑
          path: '/Admin/Score/Edit/:id',
          name: 'Admin_Score_Edit',
          component: () =>
            import('../views/Admin/Score/Edit.vue'),
          meta: {
            title: "班级成绩 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //班级成绩 汇总
          path: '/Admin/Score/Course',
          name: 'Admin_Score_Course',
          component: () =>
            import('../views/Admin/Score/Course.vue'),
          meta: {
            title: "班级成绩 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //班级成绩 录入
          path: '/Admin/Score/AdviserScoreRecord',
          name: 'Admin_Score_AdviserScoreRecord',
          component: () =>
            import('../views/Admin/Score/AdviserScoreRecord.vue'),
          meta: {
            title: "班级成绩 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            处分管理 StudentPunish
        **********************************************************************************/
        {
          //列表
          path: '/Admin/StudentPunish/Index',
          name: 'Admin_StudentPunish_Index',
          component: () =>
            import('../views/Admin/StudentPunish/Index.vue'),
          meta: {
            title: "处分管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //详情
          path: '/Admin/StudentPunish/Detail/:id',
          name: 'Admin_StudentPunish_Details',
          component: () =>
            import('../views/Admin/StudentPunish/Details.vue'),
          meta: {
            title: "处分管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/StudentPunish/Edit/:id',
          name: 'Admin_StudentPunish_Edit',
          component: () =>
            import('../views/Admin/StudentPunish/Update.vue'),
          meta: {
            title: "处分管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/StudentPunish/Create',
          name: 'Admin_StudentPunish_Create',
          component: () =>
            import('../views/Admin/StudentPunish/Update.vue'),
          meta: {
            title: "处分管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班主任手册 学生处分  StudentPunish
        **********************************************************************************/
        {
          //列表
          path: '/Admin/Adviser/StudentPunish/Index',
          name: 'Admin_Adviser_StudentPunish_Index',
          component: () =>
            import('../views/Admin/StudentPunish/Index.vue'),
          meta: {
            title: "学生处分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //详情
          path: '/Admin/Adviser/StudentPunish/Detail/:id',
          name: 'Admin_Adviser_StudentPunish_Details',
          component: () =>
            import('../views/Admin/StudentPunish/Details.vue'),
          meta: {
            title: "学生处分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //编辑
          path: '/Admin/Adviser/StudentPunish/Edit/:id',
          name: 'Admin_Adviser_StudentPunish_Edit',
          component: () =>
            import('../views/Admin/StudentPunish/Update.vue'),
          meta: {
            title: "学生处分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          //新增
          path: '/Admin/Adviser/StudentPunish/Create',
          name: 'Admin_Adviser_StudentPunish_Create',
          component: () =>
            import('../views/Admin/StudentPunish/Update.vue'),
          meta: {
            title: "学生处分 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班主任手册撤销  StudentPunishRevocation
        **********************************************************************************/
        {
          //列表
          path: '/Admin/StudentPunishRevocation/Index',
          name: 'Admin_StudentPunishRevocation_Index',
          component: () =>
            import('../views/Admin/StudentPunishRevocation/Index.vue'),
          meta: {
            title: "处分撤销 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 撤销 新增
          path: '/Admin/StudentPunishRevocation/Create',
          name: 'Admin_StudentPunishRevocation_Create',
          component: () =>
            import('../views/Admin/StudentPunishRevocation/Create.vue'),
          meta: {
            titel: "处分撤销 - " + webTitleName() + " - " + schoolName()
          }
        },
        {
          // 撤销 查看
          path: '/Admin/StudentPunishRevocation/Detils/:id',
          name: 'Admin_StudentPunishRevocation_Detils',
          component: () =>
            import('../views/Admin/StudentPunishRevocation/Detils.vue'),
          meta: {
            title: "处分撤销 - " + webTitleName() + " - " + schoolName()
          }
        },
        {
          // 活动 列表
          path: '/Admin/activity/index/:type',
          name: 'Admin_Activity_Index',
          component: () =>
            import('../views/Admin/Activity/Index.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动附件审核 activity_img_audit
          path: '/Admin/activity/AuditAT/:Id',
          name: 'Admin_Activity_AuditAT',
          component: () =>
            import('../views/Admin/Activity/AuditAT.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/activity/create/:type',
          name: 'Admin_Activity_create',
          component: () =>
            import('../views/Admin/Activity/Update.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/activity/edit/:type/:id',
          name: 'Admin_Activity_Edit',
          component: () =>
            import('../views/Admin/Activity/Update.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/activity/range/:type/:id',
          name: 'Admin_Activity_Range',
          component: () =>
            import('../views/Admin/Activity/Range.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/activity/confirm/:type/:id',
          name: 'Admin_Activity_Confirm',
          component: () =>
            import('../views/Admin/Activity/Confirm.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/activity/roster/:type/:id',
          name: 'Admin_Activity_Roster',
          component: () =>
            import('../views/Admin/Activity/Roster.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/Activity/Delegate/:type/:id',
          name: 'Admin_Activity_Delegate',
          component: () =>
            import('../views/Admin/Activity/Delegate.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },

        {
          // 活动 列表
          path: '/Admin/activity/detail/:type/:id',
          name: 'Admin_Activity_Detail',
          component: () =>
            import('../views/Admin/Activity/Detail.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/activity/prize/:type/:id',
          name: 'Admin_Activity_Prize',
          component: () =>
            import('../views/Admin/Activity/Prize.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/activity/prizeCreate/:activityId',
          name: 'Admin_Activity_Prize_Create',
          component: () =>
            import('../views/Admin/Activity/PrizeUpdate.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },

        {
          // 活动 列表
          path: '/Admin/activity/prizeEdit/:activityId/:id',
          name: 'Admin_Activity_Prize_Edit',
          component: () =>
            import('../views/Admin/Activity/PrizeUpdate.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 活动 列表
          path: '/Admin/activity/prizeDetail/:activityId/:id',
          name: 'Admin_Activity_Prize_Detail',
          component: () =>
            import('../views/Admin/Activity/PrizeDetail.vue'),
          meta: {
            title: "活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 列表
          path: '/Admin/GrowthConfig/Index',
          name: 'Admin_GrowthConfig_Index',
          component: () =>
            import('../views/Admin/GrowthConfig/Index.vue'),
          meta: {
            title: "核心素养参数 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 详情
          path: '/Admin/GrowthConfig/Details/:Id',
          name: 'Admin_GrowthConfig_Details',
          component: () =>
            import('../views/Admin/GrowthConfig/Details.vue'),
          meta: {
            title: "核心素养参数 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            日常事务 日常动态管理 自我记录 SelfReport
        **********************************************************************************/
        {
          // 自我记录 列表
          path: '/Admin/SelfReport/Index',
          name: 'Admin_SelfReport_Index',
          component: () =>
            import('../views/Admin/SelfReport/Index.vue'),
          meta: {
            title: "学生上报 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 自我记录 详情
          path: '/Admin/SelfReport/Details/:id',
          name: 'Admin_SelfReport_Details',
          component: () =>
            import('../views/Admin/SelfReport/Details.vue'),
          meta: {
            title: "学生上报 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 自我记录 审核
          path: '/Admin/SelfReport/Audit/:id',
          name: 'Admin_SelfReport_Audit',
          component: () =>
            import('../views/Admin/SelfReport/Audit.vue'),
          meta: {
            title: "学生上报 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班主任手册 自我记录 SelfReport
        **********************************************************************************/
        {
          // 自我记录 列表
          path: '/Admin/Adviser/SelfReport/Index',
          name: 'Admin_Adviser_SelfReport_Index',
          component: () =>
            import('../views/Admin/SelfReport/Index.vue'),
          meta: {
            title: "学生上报 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 自我记录 详情
          path: '/Admin/Adviser/SelfReport/Details/:id',
          name: 'Admin_Adviser_SelfReport_Details',
          component: () =>
            import('../views/Admin/SelfReport/Details.vue'),
          meta: {
            title: "学生上报 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 自我记录 审核
          path: '/Admin/Adviser/SelfReport/Audit/:id',
          name: 'Admin_Adviser_SelfReport_Audit',
          component: () =>
            import('../views/Admin/SelfReport/Audit.vue'),
          meta: {
            title: "学生上报 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            日常事务 竞赛获奖 StudentPrize
        **********************************************************************************/
        {
          // 列表
          path: '/Admin/StudentPrize/Index',
          name: 'Admin_StudentPrize_Index',
          component: () =>
            import('../views/Admin/StudentPrize/Index.vue'),
          meta: {
            title: "竞赛获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 详情
          path: '/Admin/StudentPrize/Detail/:id',
          name: 'Admin_StudentPrize_Detail',
          component: () =>
            import('../views/Admin/StudentPrize/Details.vue'),
          meta: {
            title: "竞赛获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增
          path: '/Admin/StudentPrize/Create',
          name: 'Admin_StudentPrize_Create',
          component: () =>
            import('../views/Admin/StudentPrize/Update.vue'),
          meta: {
            title: "竞赛获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 编辑
          path: '/Admin/StudentPrize/Edit/:id',
          name: 'Admin_StudentPrize_Edit',
          component: () =>
            import('../views/Admin/StudentPrize/Update.vue'),
          meta: {
            title: "竞赛获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班主任手册 学生奖励 StudentPrize
        **********************************************************************************/
        {
          // 列表
          path: '/Admin/Adviser/StudentPrize/Index',
          name: 'Admin_Adviser_StudentPrize_Index',
          component: () =>
            import('../views/Admin/StudentPrize/Index.vue'),
          meta: {
            title: "竞赛获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 详情
          path: '/Admin/Adviser/StudentPrize/Detail/:id',
          name: 'Admin_Adviser_StudentPrize_Detail',
          component: () =>
            import('../views/Admin/StudentPrize/Details.vue'),
          meta: {
            title: "竞赛获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增
          path: '/Admin/Adviser/StudentPrize/Create',
          name: 'Admin_Adviser_StudentPrize_Create',
          component: () =>
            import('../views/Admin/StudentPrize/Update.vue'),
          meta: {
            title: "竞赛获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 编辑
          path: '/Admin/Adviser/StudentPrize/Edit/:id',
          name: 'Admin_Adviser_StudentPrize_Edit',
          component: () =>
            import('../views/Admin/StudentPrize/Update.vue'),
          meta: {
            title: "竞赛获奖 - " + webTitleName() + " - " + schoolName()
          },
        },


        /*********************************************************************************
             班干部管理  ClassCadreMgt
        **********************************************************************************/
        {
          // 列表
          path: '/Admin/Adviser/ClassCadreMgt/Index',
          name: 'Admin_Adviser_ClassCadreMgt_Index',
          component: () =>
            import('../views/Admin/Adviser/ClassCadreMgt/Index.vue'),
          meta: {
            title: "班干部管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
		             房源管理 Dorm
		        **********************************************************************************/
        {
          // 列表
          path: '/Admin/Dorm/Index',
          name: 'Admin_Dorm_Index',
          component: () =>
            import('../views/Admin/Dorm/Index.vue'),
          meta: {
            title: "房源管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增宿舍楼
          path: '/Admin/Dorm/Create',
          name: 'Admin_Dorm_Create',
          component: () =>
            import('../views/Admin/Dorm/Create.vue'),
          meta: {
            title: "房源管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增宿舍楼
          path: '/Admin/Dorm/Edit/:id',
          name: 'Admin_Dorm_Edit',
          component: () =>
            import('../views/Admin/Dorm/Create.vue'),
          meta: {
            title: "房源管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增房间信息
          path: '/Admin/Dorm/Room/:id',
          name: 'Admin_Dorm_Room',
          component: () =>
            import('../views/Admin/Dorm/Room.vue'),
          meta: {
            title: "房源管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 详情
          path: '/Admin/Dorm/Details/:id',
          name: 'Admin_Dorm_Details',
          component: () =>
            import('../views/Admin/Dorm/Details.vue'),
          meta: {
            title: "房源管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
             宿舍记录 DormCheck
        **********************************************************************************/
        {
          // 列表
          path: '/Admin/DormCheck/Index',
          name: 'Admin_DormCheck_Index',
          component: () =>
            import('../views/Admin/DormCheck/Index.vue'),
          meta: {
            title: "宿舍记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
             宿舍管理 DormManage
        **********************************************************************************/
        {
          // 列表
          path: '/Admin/DormManage/Index',
          name: 'Admin_DormManage_Index',
          component: () =>
            import('../views/Admin/DormManage/Index.vue'),
          meta: {
            title: "宿舍管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 视图
          path: '/Admin/DormManage/Building',
          name: 'Admin_DormManage_Building',
          component: () =>
            import('../views/Admin/DormManage/Building.vue'),
          meta: {
            title: "宿舍管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 视图
          path: '/Admin/DormManage/Floor/:id',
          name: 'Admin_DormManage_Floor',
          component: () =>
            import('../views/Admin/DormManage/Floor.vue'),
          meta: {
            title: "宿舍管理 - " + webTitleName() + " - " + schoolName()
          },
        },

        /*********************************************************************************
             调动日志 DormChg
        **********************************************************************************/
        {
          // 列表
          path: '/Admin/DormChg/Index',
          name: 'Admin_DormChg_Index',
          component: () =>
            import('../views/Admin/DormChg/Index.vue'),
          meta: {
            title: "调动日志 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
                 留宿停宿名单 DormSuspend
             **********************************************************************************/
        {
          // 列表
          path: '/Admin/DormStaySuspend/Index',
          name: 'Admin_DormStaySuspend_Index',
          component: () =>
            import('../views/Admin/DormStaySuspend/Index.vue'),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 新增
          path: '/Admin/DormStaySuspend/Create',
          name: 'Admin_DormStaySuspend_Create',
          component: () =>
            import('../views/Admin/DormStaySuspend/Update.vue'),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 编辑
          path: '/Admin/DormStaySuspend/Edit/:id',
          name: 'Admin_DormStaySuspend_Edit',
          component: () =>
            import('../views/Admin/DormStaySuspend/Update.vue'),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          // 查看
          path: '/Admin/DormStaySuspend/Details/:id',
          name: 'Admin_DormStaySuspend_Details',
          component: () =>
            import('../views/Admin/DormStaySuspend/Details.vue'),
          meta: {
            title: "留宿停宿名单 - " + webTitleName() + " - " + schoolName()
          },
        },


        /*********************************************************************************
             核心素养参数 CoreLiteracy
        **********************************************************************************/
        {
          // 列表
          path: '/Admin/CoreLiteracy/Index',
          name: 'Admin_CoreLiteracy_Index',
          component: () =>
            import('../views/Admin/CoreLiteracy/Index.vue'),
          meta: {
            title: "核心素养参数 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            专业部管理 College
        **********************************************************************************/
        {
          path: '/Admin/College/Index',
          name: 'Admin_College_Index',
          component: () =>
            import('../views/Admin/College/Index.vue'),
          meta: {
            title: "专业部管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            专业管理 Major
        **********************************************************************************/
        {
          path: '/Admin/Major/Index',
          name: 'Admin_Major_Index',
          component: () =>
            import('../views/Admin/Major/Index.vue'),
          meta: {
            title: "专业管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班级管理 Class
        **********************************************************************************/
        {
          path: '/Admin/Class/Index',
          name: 'Admin_Class_Index',
          component: () =>
            import('../views/Admin/Class/Index.vue'),
          meta: {
            title: "班级管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Class/Create',
          name: 'Admin_Class_Create',
          component: () =>
            import('../views/Admin/Class/Edit.vue'),
          meta: {
            title: "班级管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Class/Detail/:id',
          name: 'Admin_Class_Detail',
          component: () =>
            import('../views/Admin/Class/Detail.vue'),
          meta: {
            title: "班级管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Class/Edit/:id',
          name: 'Admin_Class_Edit',
          component: () =>
            import('../views/Admin/Class/Edit.vue'),
          meta: {
            title: "班级管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班级获奖 ClassPrize
        **********************************************************************************/
        {
          path: '/Admin/ClassPrize/Index',
          name: 'Admin_ClassPrize_Index',
          component: () =>
            import('../views/Admin/ClassPrize/Index.vue'),
          meta: {
            title: "班级获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ClassPrize/Create',
          name: 'Admin_ClassPrize_Create',
          component: () =>
            import('../views/Admin/ClassPrize/Create.vue'),
          meta: {
            title: "班级获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ClassPrize/Details/:id',
          name: 'Admin_ClassPrize_Details',
          component: () =>
            import('../views/Admin/ClassPrize/Details.vue'),
          meta: {
            title: "班级获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ClassPrize/Edit/:id',
          name: 'Admin_ClassPrize_Edit',
          component: () =>
            import('../views/Admin/ClassPrize/Create.vue'),
          meta: {
            title: "班级获奖 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班级获奖类型 ClassPrizeType
        **********************************************************************************/
        {
          path: '/Admin/ClassPrizeType/Index',
          name: 'Admin_ClassPrizeType_Index',
          component: () =>
            import('../views/Admin/ClassPrizeType/Index.vue'),
          meta: {
            title: "班级获奖类型 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ClassPrizeType/Create',
          name: 'Admin_ClassPrizeType_Create',
          component: () =>
            import('../views/Admin/ClassPrizeType/Create.vue'),
          meta: {
            title: "班级获奖类型 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ClassPrizeType/Details/:id',
          name: 'Admin_ClassPrizeType_Details',
          component: () =>
            import('../views/Admin/ClassPrizeType/Details.vue'),
          meta: {
            title: "班级获奖类型 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ClassPrizeType/Edit/:id',
          name: 'Admin_ClassPrizeType_Edit',
          component: () =>
            import('../views/Admin/ClassPrizeType/Create.vue'),
          meta: {
            title: "班级获奖类型 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            班级获奖级别 ClassPrizeLevel
        **********************************************************************************/
        {
          path: '/Admin/ClassPrizeLevel/Index',
          name: 'Admin_ClassPrizeLevel_Index',
          component: () =>
            import('../views/Admin/ClassPrizeLevel/Index.vue'),
          meta: {
            title: "班级获奖级别 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
           校历管理 SemesterDay
        **********************************************************************************/
        {
          path: '/Admin/SemesterDay/Index',
          name: 'Admin_SemesterDay_Index',
          component: () =>
            import('../views/Admin/SemesterDay/Index.vue'),
          meta: {
            title: "校历管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            学年管理 Academic
        **********************************************************************************/
        {
          path: '/Admin/Academic/Index',
          name: 'Admin_Academic_Index',
          component: () =>
            import('../views/Admin/Academic/Index.vue'),
          meta: {
            title: "学年管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            学期管理 Semester
        **********************************************************************************/
        {
          path: '/Admin/Semester/Index',
          name: 'Admin_Semester_Index',
          component: () =>
            import('../views/Admin/Semester/Index.vue'),
          meta: {
            title: "学期管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Semester/Edit/:id',
          name: 'Admin_Semester_Edit',
          component: () =>
            import('../views/Admin/Semester/Operation.vue'),
          meta: {
            title: "学期管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Semester/Create',
          name: 'Admin_Semester_Create',
          component: () =>
            import('../views/Admin/Semester/Operation.vue'),
          meta: {
            title: "学期管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Semester/Detail/:id',
          name: 'Admin_Semester_Detail',
          component: () =>
            import('../views/Admin/Semester/Detail.vue'),
          meta: {
            title: "学期管理 - " + webTitleName() + " - " + schoolName()
          },
        },

        /*********************************************************************************
            课程管理 Course
        **********************************************************************************/
        {
          path: '/Admin/Course/Index',
          name: 'Admin_Course_Index',
          component: () =>
            import('../views/Admin/Course/Index.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Course/Batch',
          name: 'Admin_Course_Batch',
          component: () =>
            import('../views/Admin/Course/Batch.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Course/Create',
          name: 'Admin_Course_Create',
          component: () =>
            import('../views/Admin/Course/Operation.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Course/Edit/:id',
          name: 'Admin_Course_Edit',
          component: () =>
            import('../views/Admin/Course/Operation.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Course/Detail/:id',
          name: 'Admin_Course_Detail',
          component: () =>
            import('../views/Admin/Course/Detail.vue'),
          meta: {
            title: "课程管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            活动层级 ActivityLevel
        **********************************************************************************/
        {
          path: '/Admin/ActivityLevel/Index',
          name: 'Admin_ActivityLevel_Index',
          component: () =>
            import('../views/Admin/ActivityLevel/Index.vue'),
          meta: {
            title: "活动层级 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            活动配置 ActiveConfig
        **********************************************************************************/
        {
          path: '/Admin/ActiveConfig/Index',
          name: 'Admin_ActiveConfig_Index',
          component: () =>
            import('../views/Admin/ActiveConfig/Index.vue'),
          meta: {
            title: "活动配置 - " + webTitleName() + " - " + schoolName()
          },
        },

        {
          path: '/Admin/ActiveConfig/Create',
          name: 'Admin_ActiveConfig_Create',
          component: () =>
            import('../views/Admin/ActiveConfig/Create.vue'),
          meta: {
            title: "活动配置 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/ActiveConfig/Edit/:id',
          name: 'Admin_ActiveConfig_Edit',
          component: () =>
            import('../views/Admin/ActiveConfig/Create.vue'),
          meta: {
            title: "活动配置 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            素养报告 LiteracyReport
        **********************************************************************************/
        {
          path: '/Admin/LiteracyReport/Details/:id',
          name: 'Admin_LiteracyReport_Details',
          component: () =>
            import('../views/Admin/LiteracyReport/Details.vue'),
          meta: {
            title: "素养报告 - " + webTitleName() + " - " + schoolName()
          },
        },

        /*********************************************************************************
            用户管理 User
        *********************************************************************************/
        {
          path: '/Admin/User/Index',
          name: 'Admin_User_Index',
          component: () =>
            import('../views/Admin/User/Index.vue'),
          meta: {
            title: "用户管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/User/Create',
          name: 'Admin_User_Create',
          component: () =>
            import('../views/Admin/User/Update.vue'),
          meta: {
            title: "用户管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/User/Edit/:id',
          name: 'Admin_User_Edit',
          component: () =>
            import('../views/Admin/User/Update.vue'),
          meta: {
            title: "用户管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/User/Detail/:id',
          name: 'Admin_User_Detail',
          component: () =>
            import('../views/Admin/User/Detail.vue'),
          meta: {
            title: "用户管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/User/Filter/:id',
          name: 'Admin_User_Filter',
          component: () =>
            import('../views/Admin/User/Filter.vue'),
          meta: {
            title: "用户管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            角色管理 Index
        *********************************************************************************/
        {
          path: '/Admin/Role/Index',
          name: 'Admin_Role_Index',
          component: () =>
            import('../views/Admin/Role/Index.vue'),
          meta: {
            title: "角色管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Role/Create',
          name: 'Admin_Role_Create',
          component: () =>
            import('../views/Admin/Role/Update.vue'),
          meta: {
            title: "角色管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Role/Edit/:id',
          name: 'Admin_Role_Edit',
          component: () =>
            import('../views/Admin/Role/Update.vue'),
          meta: {
            title: "角色管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Role/Power/:id',
          name: 'Admin_Role_Power',
          component: () =>
            import('../views/Admin/Role/Power.vue'),
          meta: {
            title: "角色管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/admin/StudentRole/Power/:id',
          name: 'Admin_StudentRole_Power',
          component: () =>
            import('../views/Admin/StudentRole/Power.vue'),
          meta: {
            title: "角色管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Role/Detail/:id',
          name: 'Admin_Role_Detail',
          component: () =>
            import('../views/Admin/Role/Detail.vue'),
          meta: {
            title: "角色管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            学生角色 Index
        *********************************************************************************/
        {
          path: '/Admin/StudentRole/Index',
          name: 'Admin_StudentRole_Index',
          component: () =>
            import('../views/Admin/StudentRole/Index.vue'),
          meta: {
            title: "学生角色 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/StudentRole/Create',
          name: 'Admin_StudentRole_Create',
          component: () =>
            import('../views/Admin/StudentRole/Create.vue'),
          meta: {
            title: "学生角色 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/StudentRole/Edit/:id',
          name: 'Admin_StudentRole_Edit',
          component: () =>
            import('../views/Admin/StudentRole/Create.vue'),
          meta: {
            title: "学生角色 - " + webTitleName() + " - " + schoolName()
          },
        },
        //学生角色查看
        {
          path: '/Admin/StudentRole/Detail/:id',
          name: 'Admin_StudentRole_Detail',
          component: () =>
            import('../views/Admin/StudentRole/Detail.vue'),
          meta: {
            title: "学生角色 - " + webTitleName() + " - " + schoolName()
          },
        },

        /*********************************************************************************
            操作日志 OperationLog
        *********************************************************************************/
        { // 教师
          path: '/Admin/OperationLog/Teacher/Index',
          name: 'Admin_OperationLog_Teacher_Index',
          component: () =>
            import('../views/Admin/OperationLog/Teacher/Index.vue'),
          meta: {
            title: "操作日志 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 教师
          path: '/Admin/OperationLog/Teacher/Details/:Id',
          name: 'Admin_OperationLog_Teacher_Details',
          component: () =>
            import('../views/Admin/OperationLog/Teacher/Details.vue'),
          meta: {
            title: "操作日志 - " + webTitleName() + " - " + schoolName()
          },
        },

        /*********************************************************************************
            异常日志 ExceptionLog
        *********************************************************************************/
        { // 教师
          path: '/Admin/ExceptionLog/Teacher/Index',
          name: 'Admin_ExceptionLog_Teacher_Index',
          component: () =>
            import('../views/Admin/ExceptionLog/Teacher/Index.vue'),
          meta: {
            title: "操作日志 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 教师
          path: '/Admin/ExceptionLog/Teacher/Details/:id',
          name: 'Admin_ExceptionLog_Teacher_Details',
          component: () =>
            import('../views/Admin/ExceptionLog/Teacher/Details.vue'),
          meta: {
            title: "操作日志 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            系統功能 Action
        *********************************************************************************/
        {
          path: '/Admin/Action/Index',
          name: 'Admin_Action_Index',
          component: () =>
            import('../views/Admin/Action/Index.vue'),
          meta: {
            title: "系统功能 - " + webTitleName() + " - " + schoolName()
          },
        },

        {
          path: '/Admin/Action/Student',
          name: 'Student_Action_Index',
          component: () =>
            import('../views/Admin/Action/Student.vue'),
          meta: {
            title: "系统功能 - " + webTitleName() + " - " + schoolName()
          },
        }, {
          path: '/Admin/Action/Home',
          name: 'Admin_Action_Home',
          component: () =>
            import('../views/Admin/Action/Home.vue'),
          meta: {
            title: "部署功能 - " + webTitleName() + " - " + schoolName()
          },
        },
        /********************************************************************************
        部门管理 Department
        **********************************************************************************/
        {
          path: '/Admin/Department/Index',
          name: 'Admin_Department_Index',
          component: () =>
            import('../views/Admin/Department/Index.vue'),
          meta: {
            title: "部门管理 - " + webTitleName() + " - " + schoolName()
          },
        },
        // {
        //     path: '/Admin/Department/Create',
        //     name: 'Admin_Department_Create',
        //     component: () =>
        //         import ('../views/Admin/Department/Create.vue'),
        //     meta: {
        //         title: "部门管理"
        //     },
        // },
        /*********************************************************************************
        /*********************************************************************************
            数据字典 DataDictionary
        *********************************************************************************/
        { // 民族
          path: '/Admin/DataDictionary/Nation',
          name: 'Admin_DataDictionary_Nation',
          component: () =>
            import('../views/Admin/DataDictionary/Nation.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },

        { // 政策面貌
          path: '/Admin/DataDictionary/Political',
          name: 'Admin_DataDictionary_Political',
          component: () =>
            import('../views/Admin/DataDictionary/Political.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 奖励类型
          path: '/Admin/DataDictionary/Prize/Type',
          name: 'Admin_DataDictionary_Prize_Type',
          component: () =>
            import('../views/Admin/DataDictionary/Prize/Type.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 奖励级别
          path: '/Admin/DataDictionary/Prize/Level',
          name: 'Admin_DataDictionary_Prize_Level',
          component: () =>
            import('../views/Admin/DataDictionary/Prize/Level.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 奖励类型-新增
          path: '/Admin/DataDictionary/Prize/Type/Create',
          name: 'Admin_DataDictionary_Prize_Type_Create',
          component: () =>
            import('../views/Admin/DataDictionary/Prize/Update.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 奖励类型-编辑
          path: '/Admin/DataDictionary/Prize/Type/Edit/:id',
          name: 'Admin_DataDictionary_Prize_Type_Edit',
          component: () =>
            import('../views/Admin/DataDictionary/Prize/Update.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 奖励类型-查看
          path: '/Admin/DataDictionary/Prize/Type/Detail/:id',
          name: 'Admin_DataDictionary_Prize_Type_Detail',
          component: () =>
            import('../views/Admin/DataDictionary/Prize/Detail.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },

        { // 处分类型
          path: '/Admin/DataDictionary/Punish/Type',
          name: 'Admin_DataDictionary_Punish_Type',
          component: () =>
            import('../views/Admin/DataDictionary/Punish/Type.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 处分原因
          path: '/Admin/DataDictionary/Punish/Reason',
          name: 'Admin_DataDictionary_Punish_Reason',
          component: () =>
            import('../views/Admin/DataDictionary/Punish/Reason.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 处分原因 - 新增
          path: '/Admin/DataDictionary/Punish/Reason/Create',
          name: 'Admin_DataDictionary_Punish_Reason_Create',
          component: () =>
            import('../views/Admin/DataDictionary/Punish/Update.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 处分原因 - 编辑
          path: '/Admin/DataDictionary/Punish/Reason/Edit/:id',
          //component: resolve => require(['@/views/Admin/DataDictionary/Punish/Update.vue'], resolve),
          name: 'Admin_DataDictionary_Punish_Reason_Edit',
          component: () =>
            import('../views/Admin/DataDictionary/Punish/Update.vue'),
          meta: {
            title: "处分原因 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 处分原因 - 查看
          path: '/Admin/DataDictionary/Punish/Reason/Detail/:id',
          component: resolve => require(['@/views/Admin/DataDictionary/Punish/Detail.vue'], resolve),
          name: 'Admin_DataDictionary_Punish_Reason_Detail',
          meta: {
            title: "处分原因 - " + webTitleName() + " - " + schoolName()
          },
        },


        { // 扣分类型
          path: '/Admin/MoralityReason/Type',
          name: 'Admin_MoralityReason_Type',
          component: () =>
            import('../views/Admin/MoralityReason/Type.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 扣分原因
          path: '/Admin/MoralityReason/Index',
          name: 'Admin_MoralityReason_Index',
          component: () =>
            import('../views/Admin/MoralityReason/Index.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 扣分原因
          path: '/Admin/MoralityReason/Create/:Type',
          name: 'Admin_MoralityReason_Create',
          component: () =>
            import('../views/Admin/MoralityReason/Reason.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 扣分原因
          path: '/Admin/MoralityReason/Update/:Type/:Id',
          name: 'Admin_MoralityReason_Update',
          component: () =>
            import('../views/Admin/MoralityReason/Reason.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            日常行为
        *********************************************************************************/
        { // 列表
          path: '/Admin/Morality/Index',
          name: 'Admin_Morality_Index',
          component: () =>
            import('../views/Admin/Morality/Index.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 新增
          path: '/Admin/Morality/Create/:type',
          name: 'Admin_Morality_Create',
          component: () =>
            import('../views/Admin/Morality/Update.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 编辑
          path: '/Admin/Morality/Edit/:type/:id',
          name: 'Admin_Morality_Edit',
          component: () =>
            import('../views/Admin/Morality/Update.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 查看
          path: '/Admin/Morality/Detail/:type/:id',
          name: 'Admin_Morality_Detail',
          component: () =>
            import('../views/Admin/Morality/Detail.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 落实
          path: '/Admin/Morality/Implement/:id',
          name: 'Admin_Morality_Implement',
          component: () =>
            import('../views/Admin/Morality/Implement.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
           班主任手册 日常行为
        *********************************************************************************/
        {
          path: '/Admin/Adviser/Morality/Index',
          name: 'Admin_Adviser_Morality_Index',
          component: () =>
            import('../views/Admin/Morality/Index.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        { //查看
          path: '/Admin/Adviser/Morality/Detail/:type/:id',
          name: 'Admin_Adviser_Morality_Detail',
          component: () =>
            import('../views/Admin/Morality/Detail.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 落实
          path: '/Admin/Adviser/Morality/Implement/:id',
          name: 'Admin_Adviser_Morality_Implement',
          component: () =>
            import('../views/Admin/Morality/Implement.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
          宿舍扣分
        *********************************************************************************/
        { // 列表
          path: '/Admin/Dormitory/Index',
          name: 'Admin_Dormitory_Index',
          component: () =>
            import('../views/Admin/Dormitory/Index.vue'),
          meta: {
            title: "宿舍扣分 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 新增
          path: '/Admin/Dormitory/Create/:type',
          name: 'Admin_Dormitory_Create',
          component: () =>
            import('../views/Admin/Dormitory/Update.vue'),
          meta: {
            title: "宿舍扣分 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 编辑
          path: '/Admin/Dormitory/Edit/:type/:id',
          name: 'Admin_Dormitory_Edit',
          component: () =>
            import('../views/Admin/Dormitory/Update.vue'),
          meta: {
            title: "宿舍扣分 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 查看
          path: '/Admin/Dormitory/Detail/:type/:id',
          name: 'Admin_Dormitory_Detail',
          component: () =>
            import('../views/Admin/Dormitory/Detail.vue'),
          meta: {
            title: "宿舍扣分 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
           班主任手册-宿舍扣分
        *********************************************************************************/
        { // 列表
          path: '/Admin/Adviser/Dormitory/Index',
          name: 'Admin_Adviser_Dormitory_Index',
          component: () =>
            import('../views/Admin/Dormitory/Index.vue'),
          meta: {
            title: "宿舍扣分 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 查看
          path: '/Admin/Adviser/Dormitory/Detail/:type/:id',
          name: 'Admin_Adviser_Dormitory_Detail',
          component: () =>
            import('../views/Admin/Dormitory/Detail.vue'),
          meta: {
            title: "宿舍扣分 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 落实
          path: '/Admin/Adviser/Dormitory/Implement/:id',
          name: 'Admin_Adviser_Dormitory_Implement',
          component: () =>
            import('../views/Admin/Dormitory/Implement.vue'),
          meta: {
            title: "宿舍扣分 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************

        *********************************************************************************/



        { // 活动角色
          path: '/Admin/DataDictionary/Activity/Position',
          name: 'Admin_DataDictionary_Activity_Position',
          component: () =>
            import('../views/Admin/DataDictionary/Activity/Position.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 活动角色
          path: '/Admin/DataDictionary/Activity/Type',
          name: 'Admin_DataDictionary_Activity_Type',
          component: () =>
            import('../views/Admin/DataDictionary/Activity/Type.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 组织管理
          path: '/Admin/DataDictionary/Tissue',
          name: 'Admin_DataDictionary_Tissue',
          component: () =>
            import('../views/Admin/DataDictionary/Tissue.vue'),
          meta: {
            title: "数据字典 - " + webTitleName() + " - " + schoolName()
          },
        },
        /*********************************************************************************
            登录日志 LoginForLog
        *********************************************************************************/
        { // 教师登录日志
          path: '/Admin/LOGLog/Teacher/Index',
          name: 'Admin_LOGLog_Teacher_Index',
          component: () =>
            import('../views/Admin/LOGLog/Teacher/Index.vue'),
          meta: {
            title: "登录日志 - " + webTitleName() + " - " + schoolName()
          },
        },
        { // 教师登录日志
          path: '/Admin/LOGLog/Teacher/Details/:Id',
          name: 'Admin_LOGLog_Teacher_Details',
          component: () =>
            import('../views/Admin/LOGLog/Teacher/Details.vue'),
          meta: {
            title: "登录日志 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          短信群发
        *******************************************************************************************/
        {
          path: '/Admin/Smsmass/Index',
          name: 'Admin_Smsmass_Index',
          component: () =>
            import('../views/Admin/Smsmass/Index.vue'),
          meta: {
            title: "短信群发 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Smsmass/Create',
          name: 'Admin_Smsmass_Create',
          component: () =>
            import('../views/Admin/Smsmass/Update.vue'),
          meta: {
            title: "短信群发 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Smsmass/Edit/:Id',
          name: 'Admin_Smsmass_Edit',
          component: () =>
            import('../views/Admin/Smsmass/Update.vue'),
          meta: {
            title: "短信群发 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Admin/Smsmass/Details/:Id',
          name: 'Admin_Smsmass_Details',
          component: () =>
            import('../views/Admin/Smsmass/Details.vue'),
          meta: {
            title: "短信群发 - " + webTitleName() + " - " + schoolName()
          },
        },
      ]
    },
    /*
     ************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************ 学生PC端 ******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************
     */
    {
      path: '/Student/Default',
      name: 'Student/Default',
      component: () =>
        import('../views/Student/Default.vue'),
      meta: {
        title: schoolName()
      },
      //redirect:'/Home/Index',// 默认起始页
      children: [
        //**********> Home <*************** 首页
        {
          path: '/Student/Home/Index',
          name: 'Student_Home_Index',
          component: () =>
            import('../views/Student/Home/Index.vue'),
          meta: {
            title: schoolName()
          },
        },
        /******************************************************************************************
          我的缴费记录
        *******************************************************************************************/
        {
          path: '/Student/Payment/Index',
          name: 'Student_Payment_Index',
          component: () =>
            import('../views/Student/Payment/Index.vue'),
          meta: {
            title: "缴费记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          在线考试
        *******************************************************************************************/
        {
          path: '/Student/ExamMGT/Index',
          name: 'Student_ExamMGT_Index',
          component: () =>
            import('../views/Student/ExamMGT/Index.vue'),
          meta: {
            title: "在线考试 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/ExamMGT/Exam/:Id',
          name: 'Student_ExamMGT_Exam',
          component: () =>
            import('../views/Student/ExamMGT/Update.vue'),
          meta: {
            title: "在线考试 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/ExamMGT/MyExam',
          name: 'Student_ExamMGT_MyExam',
          component: () =>
            import('../views/Student/ExamMGT/Details.vue'),
          meta: {
            title: "我的考试信息 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          群发通知
        *******************************************************************************************/
        {
          path: '/Student/GroupNotification/Index',
          name: 'Student_GroupNotification_Index',
          component: () =>
            import('../views/Student/GroupNotification/Index.vue'),
          meta: {
            title: "群发通知 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          学生请假
        *******************************************************************************************/
        {
          path: '/Student/LeaveMGT/Index',
          name: 'Student_LeaveMGT_Index',
          component: () =>
            import('../views/Student/LeaveMGT/Index.vue'),
          meta: {
            title: "我的请假 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/LeaveMGT/Default/:Id',
          name: 'Student_LeaveMGT_Default',
          component: () =>
            import('../views/Student/LeaveMGT/Default.vue'),
          meta: {
            title: "我的请假 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/LeaveMGT/Create',
          name: 'Student_LeaveMGT_Create',
          component: () =>
            import('../views/Student/LeaveMGT/Update.vue'),
          meta: {
            title: "我的请假 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/LeaveMGT/Edit/:Id',
          name: 'Student_LeaveMGT_Edit',
          component: () =>
            import('../views/Student/LeaveMGT/Update.vue'),
          meta: {
            title: "我的请假 - " + webTitleName() + " - " + schoolName()
          },
        },

        /******************************************************************************************
          德育学分
        *******************************************************************************************/
        {
          path: '/Student/MoralEducation/Index',
          name: 'Student_MoralEducation_Index',
          component: () =>
            import('../views/Student/MoralEducation/Index.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MoralEducation/Index2',
          name: 'Student_MoralEducation_Index2',
          component: () =>
            import('../views/Student/MoralEducation/Index2.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MoralEducation/Details/:id',
          name: 'Student_MoralEducation_Details',
          component: () =>
            import('../views/Student/MoralEducation/Details.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MoralEducation/Create',
          name: 'Student_MoralEducation_Create',
          component: () =>
            import('../views/Student/MoralEducation/Update.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MoralEducation/Create2',
          name: 'Student_MoralEducation_Create2',
          component: () =>
            import('../views/Student/MoralEducation/Update2.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MoralEducation/Edit/:Id',
          name: 'Student_MoralEducation_Edit',
          component: () =>
            import('../views/Student/MoralEducation/Update.vue'),
          meta: {
            title: "德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MyMoraleducation/Index',
          name: 'Student_MyMoraleducation_Index',
          component: () =>
            import('../views/Student/MyMoraleducation/Index.vue'),
          meta: {
            title: " 我的德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MyMoraleducation/Details/:id',
          name: 'Student_MyMoraleducation_Details',
          component: () =>
            import('../views/Student/MyMoraleducation/Details.vue'),
          meta: {
            title: " 我的德育学分 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          学校社团
        *******************************************************************************************/
        {
          path: '/Student/Club/ClubMGMT/Index',
          name: 'Student_Club_ClubMGMT_Index',
          component: () =>
            import('../views/Student/Club/ClubMGMT/Index.vue'),
          meta: {
            title: "学校社团 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/Club/ClubMGMT/Details/:Id',
          name: 'Student_Club_ClubMGMT_Details',
          component: () =>
            import('../views/Student/Club/ClubMGMT/Details.vue'),
          meta: {
            title: "学校社团 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
         我的奖学金
        *******************************************************************************************/
        {
          path: '/Student/ScholarshipMGT/Index',
          name: 'Student_ScholarshipMGT_Index',
          component: () =>
            import('../views/Student/ScholarshipMGT/Index.vue'),
          meta: {
            title: " 我的奖学金 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/ScholarshipMGT/Create',
          name: 'Student_ScholarshipMGT_Create',
          component: () =>
            import('../views/Student/ScholarshipMGT/Update.vue'),
          meta: {
            title: " 我的奖学金 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/ScholarshipMGT/Details/:Id',
          name: 'Student_ScholarshipMGT_Details',
          component: () =>
            import('../views/Student/ScholarshipMGT/Details.vue'),
          meta: {
            title: " 我的奖学金 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/ScholarshipMGT/Edit/:Id',
          name: 'Student_ScholarshipMGT_Edit',
          component: () =>
            import('../views/Student/ScholarshipMGT/Update.vue'),
          meta: {
            title: " 我的奖学金 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          社团活动
        *******************************************************************************************/
        {
          path: '/Student/Club/ClubActivities/Index',
          name: 'Student_Club_ClubActivities_Index',
          component: () =>
            import('../views/Student/Club/ClubActivities/Index.vue'),
          meta: {
            title: "社团活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/Club/ClubActivities/Create/:clubId',
          name: 'Student_Club_ClubActivities_Create',
          component: () =>
            import('../views/Student/Club/ClubActivities/Update.vue'),
          meta: {
            title: "社团活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/Club/ClubActivities/Edit/:clubId/:Id',
          name: 'Student_Club_ClubActivities_Edit',
          component: () =>
            import('../views/Student/Club/ClubActivities/Update.vue'),
          meta: {
            title: "社团活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/Club/ClubActivities/Details/:Id',
          name: 'Student_Club_ClubActivities_Details',
          component: () =>
            import('../views/Student/Club/ClubActivities/Details.vue'),
          meta: {
            title: "社团活动 - " + webTitleName() + " - " + schoolName()
          },
        },


        /******************************************************************************************
          奖励记录
        *******************************************************************************************/
        {
          path: '/Student/Prize/Index',
          name: 'Student_Prize_Index',
          component: () =>
            import('../views/Student/Prize/Index.vue'),
          meta: {
            title: "奖励记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/Prize/Details/:id',
          name: 'Student_Prize_Details',
          component: () =>
            import('../views/Student/Prize/Details.vue'),
          meta: {
            title: "奖励记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          我的成绩
        *******************************************************************************************/
        {
          path: '/Student/AcademicRecord/Index',
          name: 'Student_AcademicRecord_Index',
          component: () =>
            import('../views/Student/AcademicRecord/Index.vue'),
          meta: {
            title: "我的成绩 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/AcademicRecord/Details/:id',
          name: 'Student_AcademicRecord_Details',
          component: () =>
            import('../views/Student/AcademicRecord/Details.vue'),
          meta: {
            title: "我的成绩 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          素养课程 LiteracyCourse
        *******************************************************************************************/
        {
          path: '/Student/LiteracyCourse/Index',
          name: 'Student_LiteracyCourse_Index',
          component: () =>
            import('../views/Student/LiteracyCourse/Index.vue'),
          meta: {
            title: "素养课程 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/LiteracyCourse/Details/:id',
          name: 'Student_LiteracyCourse_Details',
          component: () =>
            import('../views/Student/LiteracyCourse/Details.vue'),
          meta: {
            title: "素养课程 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          素养评价
        *******************************************************************************************/
        {
          path: '/Student/Growth/Index',
          name: 'Student_Growth_Index',
          component: () =>
            import('../views/Student/Growth/Index.vue'),
          meta: {
            title: "素养评价 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          处分记录
        *******************************************************************************************/
        {
          path: '/Student/Punish/Index',
          name: 'Student_Punish_Index',
          component: () =>
            import('../views/Student/Punish/Index.vue'),
          meta: {
            title: "处分记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/Punish/Details/:id',
          name: 'Student_Punish_Details',
          component: () =>
            import('../views/Student/Punish/Details.vue'),
          meta: {
            title: "处分记录 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          日常活动
        *******************************************************************************************/
        {
          path: '/Student/LiteracyActivities/Index',
          name: 'Student_LiteracyActivities_Index',
          component: () =>
            import('../views/Student/LiteracyActivities/Index.vue'),
          meta: {
            title: "日常活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/LiteracyActivities/Details/:id',
          name: 'Student_LiteracyActivities_Details',
          component: () =>
            import('../views/Student/LiteracyActivities/Details.vue'),
          meta: {
            title: "日常活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/LiteracyActivities/Upload/:id',
          name: 'Student_LiteracyActivities_Upload',
          component: () =>
            import('../views/Student/LiteracyActivities/Upload.vue'),
          meta: {
            title: "日常活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/LiteracyActivities/Enroll/:id',
          name: 'Student_LiteracyActivities_Enroll',
          component: () =>
            import('../views/Student/LiteracyActivities/Enroll.vue'),
          meta: {
            title: "日常活动 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          日常行为
        *******************************************************************************************/
        {
          path: '/Student/BehaviorRecord/Index',
          name: 'Student_BehaviorRecord_Index',
          component: () =>
            import('../views/Student/BehaviorRecord/Index.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/BehaviorRecord/Details/:type/:id',
          name: 'Student_BehaviorRecord_Details',
          component: () =>
            import('../views/Student/BehaviorRecord/Details.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/BehaviorRecord/Create/:type',
          name: 'Student_BehaviorRecord_Create',
          component: () =>
            import('../views/Student/BehaviorRecord/Create.vue'),
          meta: {
            title: "日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          我的日常行为
        *******************************************************************************************/
        {
          path: '/Student/MyBehaviorRecord/Index',
          name: 'Student_MyBehaviorRecord_Index',
          component: () =>
            import('../views/Student/MyBehaviorRecord/Index.vue'),
          meta: {
            title: "我的日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MyBehaviorRecord/Details/:type/:id',
          name: 'Student_MyBehaviorRecord_Details',
          component: () =>
            import('../views/Student/MyBehaviorRecord/Details.vue'),
          meta: {
            title: "我的日常行为 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          成长档案
        *******************************************************************************************/
        {
          path: '/Student/LiteracyReport/Details',
          name: 'Student_LiteracyReport_Details',
          component: () =>
            import('../views/Student/LiteracyReport/Details.vue'),
          meta: {
            title: "成长档案 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/GrowthArchives/Details',
          name: 'Student_GrowthArchives_Details',
          component: () =>
            import('../views/Student/GrowthArchives/Details.vue'),
          meta: {
            title: "成长档案 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          我的荣誉
        *******************************************************************************************/
        {
          path: '/Student/Myself/Reward/Index',
          name: 'Student_Myself_Reward_Index',
          component: () =>
            import('../views/Student/Myself/Reward/Index.vue'),
          meta: {
            title: "我的荣誉 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/Myself/Reward/Details',
          name: 'Student_Myself_Reward_Details',
          component: () =>
            import('../views/Student/Myself/Reward/Details.vue'),
          meta: {
            title: "我的荣誉 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          基础信息
        *******************************************************************************************/
        {
          path: '/Student/Myself/BaseInfo/Details',
          name: 'Student_Myself_BaseInfo_Details',
          component: () =>
            import('../views/Student/Myself/BaseInfo/Details.vue'),
          meta: {
            title: "基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/Myself/BaseInfo/Edit',
          name: 'Student_Myself_BaseInfo_Edit',
          component: () =>
            import('../views/Student/Myself/BaseInfo/Edit.vue'),
          meta: {
            title: "基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          自我记录
        *******************************************************************************************/
        {
          path: '/Student/SelfReport/Index',
          name: 'Student/SelfReport_Index',
          component: () =>
            import('../views/Student/SelfReport/Index.vue'),
          meta: {
            title: "学生上报 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/SelfReport/Create',
          name: 'Student_SelfReport_Create',
          component: () =>
            import('../views/Student/SelfReport/Create.vue'),
          meta: {
            title: "学生上报 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/SelfReport/Details/:id',
          name: 'Student_SelfReport_Details',
          component: () =>
            import('../views/Student/SelfReport/Details.vue'),
          meta: {
            title: "基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/SelfReport/Edit/:id',
          name: 'Student_SelfReport_Edit',
          component: () =>
            import('../views/Student/SelfReport/Create.vue'),
          meta: {
            title: "基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          我的选课
        *******************************************************************************************/
        {
          path: '/Student/MyCourse/Index',
          name: 'Student_MyCourse_Index',
          component: () =>
            import('../views/Student/MyCourse/Index.vue'),
          meta: {
            title: "我的选课 - " + webTitleName() + " - " + schoolName()
          },
        },
        /******************************************************************************************
          我的课表
        *******************************************************************************************/
        {
          path: '/Student/MyTimetable/Index',
          name: 'Student_MyTimetable_Index',
          component: () =>
            import('../views/Student/MyTimetable/Index.vue'),
          meta: {
            title: "基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
        {
          path: '/Student/MyWeekTimetable/Index',
          name: 'Student_MyWeekTimetable_Index',
          component: () =>
            import('../views/Student/MyTimetable/Index.vue'),
          meta: {
            title: "基础信息 - " + webTitleName() + " - " + schoolName()
          },
        },
      ]
    },
  ]
});
